import React, { useState } from 'react';
export const languageOptions = [
  { code: 'de', flag: '🇩🇪', label: 'Deutsch' },
  { code: 'en', flag: '🇬🇧', label: 'English' },
  { code: 'ru', flag: '🇷🇺', label: 'Русский' },
  { code: 'es', flag: '🇪🇸', label: 'Español' },
  { code: 'fr', flag: '🇫🇷', label: 'Français' },
  { code: 'fa', flag: '🇮🇷', label: 'فارسی' },
  { code: 'ja', flag: '🇯🇵', label: '日本語' },
  { code: 'pt', flag: '🇵🇹', label: 'Português' },
  { code: 'ar', flag: '🇸🇦', label: 'العربية' },
  { code: 'zh', flag: '🇨🇳', label: '简体中文' },
  { code: 'hi', flag: '🇮🇳', label: 'हिन्दी' },
  { code: 'tr', flag: '🇹🇷', label: 'Türkçe' },
  { code: 'it', flag: '🇮🇹', label: 'Italiano' },
  { code: 'pl', flag: '🇵🇱', label: 'Polski' },
  { code: 'uk', flag: '🇺🇦', label: 'Українська' },
  { code: 'ko', flag: '🇰🇷', label: '한국어' },
  { code: 'id', flag: '🇮🇩', label: 'Indonesia' }
];
export const translations = {
  de: {
    // Navigation
    posteingang: "Posteingang",
    gesendet: "Gesendet",
    quanten_chat: "Quanten-Chat",
    gruppen_chats: "Gruppen-Chats",
    adressbuch: "Adressbuch",
    mein_profil: "Mein Profil",
    identitaets_assistent: "Identitäts-Assistent",
    sperren: "Sperren",
    logout: "Abmelden",
    dunkler_modus: " Dunkler Modus",
    heller_modus: " Heller Modus",
    active_identity: "Aktive Identität",
    setup_profile: "Im Profil einrichten",
    // Quantum Shield
    quantum_shield_status: " Quantum Shield Status",
    post_quantum_e2e: "Post-Quanten E2E",
    aktiviert: "Aktiviert",
    quantum_shield_desc: "Das GaiaCOM-Netzwerk schützt Ihre Privatsphäre mit einem mehrschichtigen, hybriden Verschlüsselungs-Protokoll, das gegen Angriffe von zukünftigen Quantencomputern geschützt ist.",
    quantum_shield_l1_title: "1. Post-Quanten-Schutz (ML-KEM-1024)",
    quantum_shield_l1_desc: "Verwendet den FIPS 203 Standard zur Kapselung eines symmetrischen gemeinsamen Schlüssels. Verhindert das passive Aufzeichnen und spätere Entschlüsseln (\"Store Now, Decrypt Later\") durch Quantencomputer.",
    quantum_shield_l2_title: "2. Elliptic-Curve-Kryptografie (X25519)",
    quantum_shield_l2_desc: "Ein klassisches, extrem schnelles Diffie-Hellman-Schlüsselaustauschverfahren, das als zusätzliche Sicherheitsebene im Hybridverfahren dient.",
    quantum_shield_l3_title: "3. Digitale Signaturen (Ed25519)",
    quantum_shield_l3_desc: "Jede Nachricht und jeder Föderations-Umschlag wird kryptographisch signiert, um die Authentizität des Absenders zweifelsfrei zu verifizieren.",
    quantum_shield_l4_title: "4. AAD Authentifizierung (AES-256-GCM)",
    quantum_shield_l4_desc: "Verschlüsselt Nachrichteninhalte symmetrisch und bindet Absender, Empfänger und Metadaten fest in die Authentifizierten Zusatzdaten (AAD) ein, um Replay-Angriffe zu verhindern.",
    close: "Schließen",
    // Auth Screen
    auth_kicker: "Post-Quantum Secure Communication",
    auth_headline: "GaiaCOM ist das erste quantensichere E-Mail-Protokoll und Kommunikationssystem, gebaut für die Menschheit.",
    auth_subline: "GaiaCOM ist ein quantensicheres Kommunikationssystem für E-Mail, Chat, Krisenräume, GaiaDrop und lokale Sicherheitsakten. Private Schlüssel bleiben auf deinem Gerät, Inhalte werden Ende-zu-Ende verschlüsselt und Beweise können ohne Klartext exportiert werden.",
    auth_beta_notice: "Beta-Testphase: GaiaCOM wird aktiv getestet. Fehler können auftreten; sichere wichtige Seeds und prüfe vertrauliche Workflows sorgfältig.",
    auth_value_mail: "Sichere Mail",
    auth_value_chat: "E2E Chat",
    auth_value_rooms: "GaiaRooms",
    auth_value_drop: "Secure Drop",
    auth_proof_e2ee_desc: "Private Schlüssel verlassen dein Gerät nicht. Nur die vorgesehenen Empfänger können Inhalte entschlüsseln.",
    auth_proof_gaiadata_desc: "Zero-Knowledge: Du behältst die Kontrolle über deine Daten. Metadaten werden minimiert und nicht als Klartext-Profil verwertet.",
    auth_proof_hybrid_desc: "Quantum Shield: Hybride Verschlüsselung mit ML-KEM und X25519 schützt gegen heutige Angriffe und Store-Now-Decrypt-Later-Risiken.",
    auth_proof_gaiaproof_desc: "Zustell- und Integritätsbeweise zeigen, dass Ciphertext, Sender und Zeitstempel nicht manipuliert wurden.",
    auth_proof_gaiadrop_desc: "Externe Personen können vertrauliche Text-Hinweise ohne Account an deine GaiaID senden.",
    auth_proof_gaiavault_desc: "Private Notizen, Recovery-Hinweise und Security Records bleiben lokal verschlüsselt.",
    auth_usecase_title: "Für sensible Kommunikation gebaut",
    auth_usecase_text: "Geeignet für Anwälte, Unternehmen, Behörden, Journalisten, Whistleblower und private Sicherheitsfälle.",
    auth_tab_login: "Login / Account",
    auth_tab_drop: "GaiaDrop",
    public_drop_desc: "Secure Drop für externe Text-Hinweise ohne GaiaCOM Account.",
    public_drop_target: "Ziel-GaiaID",
    public_drop_sender: "Absender-Hinweis optional",
    public_drop_sender_placeholder: "Name, Aktenzeichen oder anonym",
    public_drop_message: "Nachricht",
    public_drop_message_placeholder: "Vertraulichen Text eingeben...",
    public_drop_send: "GaiaDrop senden",
    auth_secure_mail: "Secure Quantum Federated Mail",
    auth_username: "Benutzername",
    auth_username_placeholder: "Name eingeben...",
    auth_password: "Passwort",
    auth_password_placeholder: "••••••••••••",
    auth_mnemonic: "Mnemonic-Phrase",
    auth_mnemonic_placeholder: "12 Wörter durch Leerzeichen getrennt...",
    auth_generate_seed: "Seed generieren",
    auth_copy_seed: "Seed kopieren",
    auth_copied: "Kopiert",
    auth_btn_register: "Registrieren & Krypto erstellen",
    auth_btn_login: "Identität laden & einloggen",
    auth_toggle_register: "Neuen Account erstellen",
    auth_toggle_login: "Bereits Account vorhanden",
    auth_success_title: "Registrierung erfolgreich",
    auth_success_text: "Dein GaiaCOM-Konto wurde erstellt. Die Schlüssel wurden lokal aus deinem Seed abgeleitet und nicht auf dem Server gespeichert.",
    auth_success_btn: "Jetzt einloggen",
    // Unlock Screen
    unlock_title: "Identität entsperren",
    unlock_desc: "Deine private Schlüsseldatei ist verschlüsselt gespeichert. Gib dein Passwort ein, um die kryptographischen Schlüssel nur im Arbeitsspeicher zu laden.",
    unlock_btn: "Entsperren",
    unlock_logout: "Abmelden und lokale Schlüssel schließen",
    // Setup Wizard
    wizard_step1: "1. Backup Seed",
    wizard_step2: "2. Adresse & Server",
    wizard_title1: "Wiederherstellungs-Schlüssel sichern",
    wizard_desc1: "GaiaCOM speichert private Schlüssel nicht serverseitig. Ohne Mnemonic Seed kann niemand verlorene Nachrichten wiederherstellen.",
    wizard_check1: "Ich habe meinen Seed sicher gespeichert.",
    wizard_next: "Weiter",
    wizard_title2: "GaiaCOM-Adresse wählen",
    wizard_desc2: "Deine Adresse bestimmt den föderierten Node, über den verschlüsselte Umschläge geroutet werden.",
    wizard_address: "Adresse",
    wizard_custom_domain: "Eigene Domain verwenden",
    wizard_fallback: "Fallback Nodes",
    wizard_back: "Zurück",
    wizard_finish: "Einrichtung abschließen",
    // Group Settings Modal
    group_settings_title: "Gruppeneinstellungen",
    group_settings_name: "Gruppenname",
    group_settings_desc: "Beschreibung",
    group_settings_avatar: "Avatar",
    // General UI
    erfolg: "Erfolg",
    fehler: "Fehler",
    abbrechen: "Abbrechen",
    speichern: "Speichern",
    senden: "Senden",
    mail_compose: "Mail schreiben",
    antworten: "Antworten",
    gruppe_erstellen: "+ Gruppe erstellen",
    gruppe_beitreten: "Gruppe beigetreten",
    gruppe_verlassen: "Gruppe verlassen",
    einladungscode: "Einladungscode",
    code_kopieren: "Code kopieren",
    kopiert: "Kopiert",
    mitglieder: "Mitglieder",
    kanaele: "Kanäle",
    kanal_erstellen: "+ Kanal",
    mitglied: "Mitglied",
    admin: "Admin",
    suchen: "Neue Gaia-Adresse suchen...",
    profil: "Profil",
    keine_mails: "Keine Mails vorhanden.",
    laden: "Laden...",
    schluessel_entsperrt: "🔑 Schlüssel wieder sperren",
    // Profile & Password Change
    profile_details: "Profil-Details",
    biography: "Biografie",
    no_specification: "Keine Angabe",
    active_identities: "Aktive Identitäten",
    new_identity: "Neue Identität",
    setup_address_keys: "Adresse und Schlüsselsatz anlegen",
    display_name: "Anzeigename",
    bio_status: "Biografie / Status",
    choose_avatar: "Avatar wählen",
    save_profile: "Profil speichern",
    change_password_title: "Passwort ändern",
    change_password_desc: "Ändert dein serverseitiges Login-Passwort. Deine lokale Recovery Phrase bleibt separat durch dein Vault-/Unlock-Passwort geschützt.",
    current_password: "Aktuelles Passwort",
    new_password: "Neues Passwort",
    confirm_new_password: "Neues Passwort bestätigen",
    update_password: "Passwort aktualisieren",
    // Placeholders & Info
    select_contact_chat: "Wähle einen Kontakt aus dem linken Panel aus, um einen quantensicheren E2E-Chat zu starten.",
    select_mail_read: "Wähle eine Mail aus der Liste aus, um deren quantensichere Inhalte zu lesen, oder erstelle eine neue Nachricht.",
    quantum_secure_net: "GaiaCOM Quantensicheres Netzwerk (Ed25519 & ML-KEM)",
    quantum_secure_exchange: "Quantensicherer Austausch über...",
    // GaiaVault
    vault_title: "GaiaVault Secure Records",
    vault_desc: "Lokaler verschlüsselter Tresor für Recovery-Backups, Identitätsnotizen, Server-Zugänge, Notfallkontakte, Rechtsnotizen, Security Events und private Logs.",
    vault_pwd_placeholder: "Vault-Passwort eingeben...",
    vault_btn_unlock: "Tresor entsperren",
    vault_record_title_placeholder: "Titel des Secure Records",
    vault_record_body_placeholder: "Verschlüsselten Record-Inhalt eingeben...",
    vault_btn_encrypt: "Record verschlüsseln",
    vault_btn_lock: "Tresor sperren",
    vault_empty: "Noch keine Secure Records gespeichert.",
    delete: "Löschen",
    // GaiaDrop
    drop_title: "GaiaDrop Secure Inbox",
    drop_desc: "Text-only Zero-Knowledge Drop-Kanal für externe Hinweise, Responsible Disclosure und vertrauliche Meldungen. Externe können ohne Account unter Angabe deiner GaiaID Nachrichten senden.",
    drop_btn_decrypting: "Inbox wird entschlüsselt...",
    drop_btn_load: "GaiaDrop Inbox laden",
    drop_empty: "Noch keine GaiaDrop Meldungen geladen.",
    anonymous_sender: "Anonymer Absender",
    time_unknown: "Zeitpunkt unbekannt",
    decrypt_failed: "Nicht entschlüsselbar",
    // New keys for V2
    confirm_delete_msg: "Möchtest du diese Nachricht löschen?",
    confirm_delete_everyone: "Möchtest du die Nachricht für beide Partner löschen? (OK = Für alle, Abbrechen = Nur für mich)",
    confirm_clear_chat: "Möchtest du diesen Chat leeren?",
    confirm_clear_everyone: "Möchtest du den Chat für beide Partner leeren? (OK = Für alle, Abbrechen = Nur für mich)",
    edit_profile: "Profil bearbeiten",
    click_to_write_mail: "Klicken zum Schreiben einer Mail",
    message_to_channel: "Nachricht an",
    smtp_security_warning: "Diese Mail wurde über das klassische, unverschlüsselte SMTP-Protokoll übertragen. Keine End-to-End-Verschlüsselung aktiv.",
    von: "Von",
    export_disclosure: "Sicherheitsfall exportieren",
    melden: "Melden",
    attachments: "Anhänge",
    kein_chat_ausgewaehlt: "Kein Chat ausgewählt",
    room_chat_start_hint: "Starten Sie die Konversation! Alle Nachrichten in diesem Gruppenkanal sind dezentral quantensicher E2E verschlüsselt.",
    kein_kanal_ausgewaehlt: "Kein Kanal ausgewählt",
    select_channel_chat: "Wähle einen Kanal aus der linken Seitenleiste aus, um zu chatten.",
    chat_start_hint: "Starten Sie die Konversation! Alle Chat-Nachrichten sind quantensicher E2E verschlüsselt.",
    chat_input_placeholder: "Sichere Nachricht eingeben...",
    upload_avatar_btn: "Bild hochladen (Sanitized)",
    kryptographische_schluessel: "Kryptographische Schlüssel",
    profile_unlock_desc: "Aus Sicherheitsgründen müssen Sie Ihr Passwort erneut eingeben, um Ihre privaten kryptographischen Schlüssel anzuzeigen.",
    unlock_btn_profile: "Freischalten",
    e2e_chat_room_open: "E2E Chat-Raum öffnen",
    spam_verdacht: "Spam/Verdacht",
    no_description: "Keine Beschreibung",
    groups_empty_title: "Noch keine Gruppen-Chats",
    groups_empty_desc: "Erstelle einen sicheren Arbeitsraum für Projekt-, Krisen- oder Teamkommunikation."
  },
  en: {
    // Navigation
    posteingang: "Inbox",
    gesendet: "Sent",
    quanten_chat: "Quantum Chat",
    gruppen_chats: "Group Chats",
    adressbuch: "Address Book",
    mein_profil: "My Profile",
    identitaets_assistent: "Identity Wizard",
    sperren: "Lock",
    logout: "Log Out",
    dunkler_modus: " Dark Mode",
    heller_modus: " Light Mode",
    active_identity: "Active Identity",
    setup_profile: "Setup in Profile",
    // Quantum Shield
    quantum_shield_status: " Quantum Shield Status",
    post_quantum_e2e: "Post-Quantum E2E",
    aktiviert: "Enabled",
    quantum_shield_desc: "The GaiaCOM network protects your privacy with a multi-layered, hybrid encryption protocol secure against attacks from future quantum computers.",
    quantum_shield_l1_title: "1. Post-Quantum Protection (ML-KEM-1024)",
    quantum_shield_l1_desc: "Uses the FIPS 203 standard to encapsulate a symmetric shared key. Prevents passive eavesdropping and later decryption (\"Store Now, Decrypt Later\") by quantum computers.",
    quantum_shield_l2_title: "2. Elliptic-Curve Cryptography (X25519)",
    quantum_shield_l2_desc: "A classical, ultra-fast Diffie-Hellman key exchange method serving as an additional security layer in the hybrid scheme.",
    quantum_shield_l3_title: "3. Digital Signatures (Ed25519)",
    quantum_shield_l3_desc: "Every message and federation envelope is cryptographically signed to verify sender authenticity beyond doubt.",
    quantum_shield_l4_title: "4. AAD Authentication (AES-256-GCM)",
    quantum_shield_l4_desc: "Encrypts message content symmetrically and binds sender, recipient, and metadata tightly into the Authenticated Additional Data (AAD) to prevent replay attacks.",
    close: "Close",
    // Auth Screen
    auth_kicker: "Post-Quantum Secure Communication",
    auth_headline: "GaiaCOM is the first quantum-secure email protocol and communication system built for humanity.",
    auth_subline: "GaiaCOM is a quantum-secure communication system for mail, chat, crisis rooms, GaiaDrop, and local security records. Private keys stay on your device, content is end-to-end encrypted, and evidence can be exported without revealing plaintext.",
    auth_beta_notice: "Beta test phase: GaiaCOM is actively being tested. Bugs may occur; keep important seeds backed up and verify sensitive workflows carefully.",
    auth_value_mail: "Secure Mail",
    auth_value_chat: "E2E Chat",
    auth_value_rooms: "GaiaRooms",
    auth_value_drop: "Secure Drop",
    auth_proof_e2ee_desc: "Private keys never leave your device. Only intended recipients can decrypt content.",
    auth_proof_gaiadata_desc: "Zero-knowledge: You keep control of your data. Metadata is minimized and not turned into a plaintext profile.",
    auth_proof_hybrid_desc: "Quantum Shield: Hybrid encryption with ML-KEM and X25519 protects against current attacks and store-now-decrypt-later risk.",
    auth_proof_gaiaproof_desc: "Delivery and integrity proofs show that ciphertext, sender, and timestamp were not manipulated.",
    auth_proof_gaiadrop_desc: "External people can submit confidential text-only reports to your GaiaID without an account.",
    auth_proof_gaiavault_desc: "Private notes, recovery hints, and security records remain locally encrypted.",
    auth_usecase_title: "Built for sensitive communication",
    auth_usecase_text: "Designed for lawyers, companies, agencies, journalists, whistleblowers, and private security incidents.",
    auth_tab_login: "Login / Account",
    auth_tab_drop: "GaiaDrop",
    public_drop_desc: "Secure Drop for external text-only reports without a GaiaCOM account.",
    public_drop_target: "Target GaiaID",
    public_drop_sender: "Optional sender note",
    public_drop_sender_placeholder: "Name, case ID, or anonymous",
    public_drop_message: "Message",
    public_drop_message_placeholder: "Enter confidential text...",
    public_drop_send: "Send GaiaDrop",
    auth_secure_mail: "Secure Quantum Federated Mail",
    auth_username: "Username",
    auth_username_placeholder: "Enter username...",
    auth_password: "Password",
    auth_password_placeholder: "••••••••••••",
    auth_mnemonic: "Mnemonic Phrase",
    auth_mnemonic_placeholder: "12 words separated by spaces...",
    auth_generate_seed: "Generate Seed",
    auth_copy_seed: "Copy Seed",
    auth_copied: "Copied",
    auth_btn_register: "Register & Create Keys",
    auth_btn_login: "Load Identity & Log In",
    auth_toggle_register: "Create new account",
    auth_toggle_login: "Already have an account",
    auth_success_title: "Registration Successful",
    auth_success_text: "Your GaiaCOM account has been created. The keys were derived locally from your seed and not stored on the server.",
    auth_success_btn: "Log In Now",
    // Unlock Screen
    unlock_title: "Unlock Identity",
    unlock_desc: "Your private key file is stored encrypted. Enter your password to load the cryptographic keys only in RAM.",
    unlock_btn: "Unlock",
    unlock_logout: "Log out and close local keys",
    // Setup Wizard
    wizard_step1: "1. Backup Seed",
    wizard_step2: "2. Address & Server",
    wizard_title1: "Secure Recovery Keys",
    wizard_desc1: "GaiaCOM does not store private keys server-side. Without the Mnemonic Seed, no one can recover lost messages.",
    wizard_check1: "I have securely stored my seed.",
    wizard_next: "Next",
    wizard_title2: "Select GaiaCOM Address",
    wizard_desc2: "Your address determines the federated node through which encrypted envelopes are routed.",
    wizard_address: "Address",
    wizard_custom_domain: "Use custom domain",
    wizard_fallback: "Fallback Nodes",
    wizard_back: "Back",
    wizard_finish: "Finish Setup",
    // Group Settings Modal
    group_settings_title: "Group Settings",
    group_settings_name: "Group Name",
    group_settings_desc: "Description",
    group_settings_avatar: "Avatar",
    // General UI
    erfolg: "Success",
    fehler: "Error",
    abbrechen: "Cancel",
    speichern: "Save",
    senden: "Send",
    mail_compose: "Compose mail",
    antworten: "Reply",
    gruppe_erstellen: "+ Create Group",
    gruppe_beitreten: "Group Joined",
    gruppe_verlassen: "Leave Group",
    einladungscode: "Invite Code",
    code_kopieren: "Copy Code",
    kopiert: "Copied",
    mitglieder: "Members",
    kanaele: "Channels",
    kanal_erstellen: "+ Channel",
    mitglied: "Member",
    admin: "Admin",
    suchen: "Search Gaia address...",
    profil: "Profile",
    keine_mails: "No mails available.",
    laden: "Loading...",
    schluessel_entsperrt: "🔑 Lock keys again",
    // Profile & Password Change
    profile_details: "Profile Details",
    biography: "Biography",
    no_specification: "No specification",
    active_identities: "Active Identities",
    new_identity: "New Identity",
    setup_address_keys: "Create address and keys",
    display_name: "Display Name",
    bio_status: "Biography / Status",
    choose_avatar: "Choose Avatar",
    save_profile: "Save Profile",
    change_password_title: "Change Password",
    change_password_desc: "Changes your server-side login password. Your local recovery phrase remains separate and protected by your Vault/Unlock password.",
    current_password: "Current Password",
    new_password: "New Password",
    confirm_new_password: "Confirm New Password",
    update_password: "Update Password",
    // Placeholders & Info
    select_contact_chat: "Select a contact from the left panel to start a quantum-secure E2E chat.",
    select_mail_read: "Select a mail from the list to read its quantum-secure contents, or create a new message.",
    quantum_secure_net: "GaiaCOM Quantum-Secure Network (Ed25519 & ML-KEM)",
    quantum_secure_exchange: "Quantum-secure exchange via...",
    // GaiaVault
    vault_title: "GaiaVault Secure Records",
    vault_desc: "Local encrypted vault for recovery backups, identity notes, server credentials, emergency contacts, legal notes, security events, and private logs.",
    vault_pwd_placeholder: "Enter Vault password...",
    vault_btn_unlock: "Unlock Vault",
    vault_record_title_placeholder: "Title of Secure Record",
    vault_record_body_placeholder: "Enter encrypted record content...",
    vault_btn_encrypt: "Encrypt Record",
    vault_btn_lock: "Lock Vault",
    vault_empty: "No secure records stored yet.",
    delete: "Delete",
    // GaiaDrop
    drop_title: "GaiaDrop Secure Inbox",
    drop_desc: "Text-only zero-knowledge drop channel for external hints, responsible disclosure, and confidential reports. External users can send messages using your GaiaID without an account.",
    drop_btn_decrypting: "Decrypting inbox...",
    drop_btn_load: "Load GaiaDrop Inbox",
    drop_empty: "No GaiaDrop messages loaded yet.",
    anonymous_sender: "Anonymous Sender",
    time_unknown: "Time unknown",
    decrypt_failed: "Not decryptable",
    // New keys for V2
    confirm_delete_msg: "Do you want to delete this message?",
    confirm_delete_everyone: "Do you want to delete this message for both partners? (OK = For everyone, Cancel = Only for me)",
    confirm_clear_chat: "Do you want to clear this chat?",
    confirm_clear_everyone: "Do you want to clear this chat for both partners? (OK = For everyone, Cancel = Only for me)",
    edit_profile: "Edit Profile",
    click_to_write_mail: "Click to write an email",
    message_to_channel: "Message to",
    smtp_security_warning: "This mail was transmitted via the classical, unencrypted SMTP protocol. No End-to-End encryption active.",
    von: "From",
    export_disclosure: "Export Disclosure",
    melden: "Report",
    attachments: "Attachments",
    kein_chat_ausgewaehlt: "No chat selected",
    room_chat_start_hint: "Start the conversation! All messages in this group channel are decentralized, quantum-secure E2E encrypted.",
    kein_kanal_ausgewaehlt: "No channel selected",
    select_channel_chat: "Select a channel from the left sidebar to start chatting.",
    chat_start_hint: "Start the conversation! All chat messages are quantum-secure E2E encrypted.",
    chat_input_placeholder: "Enter secure message...",
    upload_avatar_btn: "Upload Image (Sanitized)",
    kryptographische_schluessel: "Cryptographic Keys",
    profile_unlock_desc: "For security reasons, you must enter your password again to view your private cryptographic keys.",
    unlock_btn_profile: "Unlock",
    e2e_chat_room_open: "Open E2E Chat Room",
    spam_verdacht: "Spam/Suspected",
    no_description: "No description",
    groups_empty_title: "No group chats yet",
    groups_empty_desc: "Create a secure workspace for project, crisis, or team communication."
  },
  ru: {
    // Navigation
    posteingang: "Входящие",
    gesendet: "Отправленные",
    quanten_chat: "Квантовый чат",
    gruppen_chats: "Групповые чаты",
    adressbuch: "Адресная книга",
    mein_profil: "Мой профиль",
    identitaets_assistent: "Помощник личности",
    sperren: "Заблокировать",
    logout: "Выйти",
    dunkler_modus: " Тёмная тема",
    heller_modus: " Светлая тема",
    active_identity: "Активная личность",
    setup_profile: "Настроить в профиле",
    // Quantum Shield
    quantum_shield_status: " Статус Quantum Shield",
    post_quantum_e2e: "Постквантовый E2E",
    aktiviert: "Активирован",
    quantum_shield_desc: "Сеть GaiaCOM защищает вашу конфиденциальность с помощью многоуровневого гибридного протокола шифрования, устойчивого к атакам будущих квантовых компьютеров.",
    quantum_shield_l1_title: "1. Постквантовая защита (ML-KEM-1024)",
    quantum_shield_l1_desc: "Использует стандарт FIPS 203 для инкапсуляции симметричного общего ключа. Предотвращает пассивный перехват и последующую расшифровку (\"Запиши сейчас, расшифруй потом\") квантовыми компьютерами.",
    quantum_shield_l2_title: "2. Эллиптическая криптография (X25519)",
    quantum_shield_l2_desc: "Классический, сверхбыстрый метод обмена ключами Диффи-Хеллмана, служащий дополнительным уровнем безопасности в гибридной схеме.",
    quantum_shield_l3_title: "3. Цифровые подписи (Ed25519)",
    quantum_shield_l3_desc: "Каждое сообщение и федеративный конверт подписываются криптографически, чтобы однозначно подтвердить подлинность отправителя.",
    quantum_shield_l4_title: "4. AAD аутентификация (AES-256-GCM)",
    quantum_shield_l4_desc: "Шифрует содержимое сообщений симметрично и жестко привязывает отправителя, получателя и метаданные к аутентифицированным дополнительным данным (AAD) для предотвращения атак повторного воспроизведения.",
    close: "Закрыть",
    // Auth Screen
    auth_headline: "GaiaCOM — первый квантово-стойкий протокол электронной почты и система связи, созданная для человечества.",
    auth_subline: "GaiaCOM — квантово-устойчивая система связи для почты, чатов, кризисных комнат, GaiaDrop и локальных записей безопасности. Закрытые ключи остаются на вашем устройстве, содержимое шифруется сквозным шифрованием, а доказательства можно экспортировать без раскрытия открытого текста.",
    auth_beta_notice: "Бета-тест: GaiaCOM активно проверяется. Возможны ошибки; храните важные seed-фразы в резерве и внимательно проверяйте критичные сценарии.",
    auth_proof_e2ee_desc: "Закрытые ключи никогда не покидают ваше устройство. Расшифровать содержимое могут только предназначенные получатели.",
    auth_proof_gaiadata_desc: "Zero-Knowledge: вы сохраняете контроль над своими данными. Метаданные минимизируются и не превращаются в открытый профиль.",
    auth_proof_hybrid_desc: "Quantum Shield: гибридное шифрование ML-KEM и X25519 защищает от современных атак и риска «сохранить сейчас, расшифровать позже».",
    auth_kicker: "Постквантовая защищенная связь",
    auth_value_mail: "Защищенная почта",
    auth_value_chat: "E2E-чат",
    auth_value_rooms: "GaiaRooms",
    auth_value_drop: "Secure Drop",
    auth_proof_gaiaproof_desc: "Доказательства доставки и целостности показывают, что шифротекст, отправитель и временная метка не были изменены.",
    auth_proof_gaiadrop_desc: "Внешние отправители могут передавать конфиденциальные текстовые сообщения на ваш GaiaID без учетной записи.",
    auth_proof_gaiavault_desc: "Личные заметки, подсказки восстановления и записи безопасности остаются локально зашифрованными.",
    auth_usecase_title: "Создано для чувствительной коммуникации",
    auth_usecase_text: "Подходит для юристов, компаний, ведомств, журналистов, информаторов и частных инцидентов безопасности.",
    auth_tab_login: "Вход / аккаунт",
    auth_tab_drop: "GaiaDrop",
    public_drop_desc: "Secure Drop для внешних текстовых обращений без аккаунта GaiaCOM.",
    public_drop_target: "Целевой GaiaID",
    public_drop_sender: "Заметка отправителя, необязательно",
    public_drop_sender_placeholder: "Имя, номер дела или анонимно",
    public_drop_message: "Сообщение",
    public_drop_message_placeholder: "Введите конфиденциальный текст...",
    public_drop_send: "Отправить GaiaDrop",
    groups_empty_title: "Групповых чатов пока нет",
    groups_empty_desc: "Создайте защищенное рабочее пространство для проекта, кризисной ситуации или командной коммуникации.",
    auth_secure_mail: "Безопасная квантовая федеративная почта",
    auth_username: "Имя пользователя",
    auth_username_placeholder: "Введите имя...",
    auth_password: "Пароль",
    auth_password_placeholder: "••••••••••••",
    auth_mnemonic: "Мнемоническая фраза",
    auth_mnemonic_placeholder: "12 слов, разделенных пробелами...",
    auth_generate_seed: "Сгенерировать сид",
    auth_copy_seed: "Копировать сид",
    auth_copied: "Скопировано",
    auth_btn_register: "Регистрация и создание ключей",
    auth_btn_login: "Загрузить личность и войти",
    auth_toggle_register: "Создать новый аккаунт",
    auth_toggle_login: "Уже есть аккаунт",
    auth_success_title: "Регистрация успешна",
    auth_success_text: "Ваш аккаунт GaiaCOM создан. Ключи были созданы локально из вашего сида и не хранятся на сервере.",
    auth_success_btn: "Войти сейчас",
    // Unlock Screen
    unlock_title: "Разблокировать личность",
    unlock_desc: "Файл вашего закрытого ключа зашифрован. Введите пароль для загрузки криптографических ключей только в оперативную память.",
    unlock_btn: "Разблокировать",
    unlock_logout: "Выйти и закрыть локальные ключи",
    // Setup Wizard
    wizard_step1: "1. Резервный сид",
    wizard_step2: "2. Адрес и Сервер",
    wizard_title1: "Защитить ключи восстановления",
    wizard_desc1: "GaiaCOM не хранит закрытые ключи на стороне сервера. Без мнемонического сида никто не сможет восстановить утерянные сообщения.",
    wizard_check1: "Я надежно сохранил свою сид-фразу.",
    wizard_next: "Далее",
    wizard_title2: "Выберите адрес GaiaCOM",
    wizard_desc2: "Ваш адрес определяет федеративный узел, через который маршрутизируются зашифрованные конверты.",
    wizard_address: "Адрес",
    wizard_custom_domain: "Использовать свой домен",
    wizard_fallback: "Резервные узлы",
    wizard_back: "Назад",
    wizard_finish: "Завершить настройку",
    // Group Settings Modal
    group_settings_title: "Настройки группы",
    group_settings_name: "Название группы",
    group_settings_desc: "Описание",
    group_settings_avatar: "Аватар",
    // General UI
    erfolg: "Успех",
    fehler: "Ошибка",
    abbrechen: "Отмена",
    speichern: "Сохранить",
    senden: "Отправить",
    mail_compose: "Написать письмо",
    antworten: "Ответить",
    gruppe_erstellen: "+ Создать группу",
    gruppe_beitreten: "Группа присоединена",
    gruppe_verlassen: "Выйти из группы",
    einladungscode: "Код приглашения",
    code_kopieren: "Копировать код",
    kopiert: "Скопировано",
    mitglieder: "Участники",
    kanaele: "Каналы",
    kanal_erstellen: "+ Канал",
    mitglied: "Участник",
    admin: "Админ",
    suchen: "Поиск адреса Gaia...",
    profil: "Профиль",
    keine_mails: "Нет писем.",
    laden: "Загрузка...",
    schluessel_entsperrt: "🔑 Снова заблокировать ключи",
    // Profile & Password Change
    profile_details: "Детали профиля",
    biography: "Биография",
    no_specification: "Не указано",
    active_identities: "Активные личности",
    new_identity: "Новая личность",
    setup_address_keys: "Создать адрес и набор ключей",
    display_name: "Отображаемое имя",
    bio_status: "Биография / Статус",
    choose_avatar: "Выбрать аватар",
    save_profile: "Сохранить профиль",
    change_password_title: "Изменить пароль",
    change_password_desc: "Изменяет ваш пароль для входа на сервере. Ваша локальная резервная фраза остается отдельно защищенной паролем Vault/Unlock.",
    current_password: "Текущий пароль",
    new_password: "Новый пароль",
    confirm_new_password: "Подтвердить новый пароль",
    update_password: "Обновить пароль",
    // Placeholders & Info
    select_contact_chat: "Выберите контакт на левой панели, чтобы начать безопасный квантово-защищенный чат E2E.",
    select_mail_read: "Выберите письмо из списка, чтобы прочитать его квантово-безопасное содержимое, или создайте новое сообщение.",
    quantum_secure_net: "Квантово-безопасная сеть GaiaCOM (Ed25519 и ML-KEM)",
    quantum_secure_exchange: "Квантово-безопасный обмен через...",
    // GaiaVault
    vault_title: "Сейф GaiaVault Secure Records",
    vault_desc: "Локальный зашифрованный сейф для резервных копий восстановления, личных заметок, учетных данных серверов, экстренных контактов, юридических заметок, событий безопасности и частных логов.",
    vault_pwd_placeholder: "Введите пароль сейфа...",
    vault_btn_unlock: "Разблокировать сейф",
    vault_record_title_placeholder: "Название записи",
    vault_record_body_placeholder: "Введите зашифрованное содержимое записи...",
    vault_btn_encrypt: "Зашифровать запись",
    vault_btn_lock: "Заблокировать сейф",
    vault_empty: "В сейфе пока нет сохраненных записей.",
    delete: "Удалить",
    // GaiaDrop
    drop_title: "Приемник GaiaDrop Secure Inbox",
    drop_desc: "Текстовый канал с нулевым разглашением для внешних сообщений, раскрытия уязвимостей и конфиденциальных отчетов. Внешние пользователи могут отправлять сообщения на ваш GaiaID без аккаунта.",
    drop_btn_decrypting: "Дешифрование папки...",
    drop_btn_load: "Загрузить GaiaDrop Inbox",
    drop_empty: "Входящих сообщений GaiaDrop пока нет.",
    anonymous_sender: "Анонимный отправитель",
    time_unknown: "Время неизвестно",
    decrypt_failed: "Не удается расшифровать",
    // New keys for V2
    confirm_delete_msg: "Вы хотите удалить это сообщение?",
    confirm_delete_everyone: "Вы хотите удалить это сообщение для обеих сторон? (OK = Для всех, Отмена = Только для меня)",
    confirm_clear_chat: "Вы хотите очистить этот чат?",
    confirm_clear_everyone: "Вы хотите очистить этот чат для обеих сторон? (OK = Для всех, Отмена = Только для меня)",
    edit_profile: "Редактировать профиль",
    click_to_write_mail: "Нажмите, чтобы написать письмо",
    message_to_channel: "Сообщение в",
    smtp_security_warning: "Это письмо было передано по классическому незашифрованному протоколу SMTP. Сквозное шифрование неактивно.",
    von: "От",
    export_disclosure: "Экспорт дела безопасности",
    melden: "Пожаловаться",
    attachments: "Вложения",
    kein_chat_ausgewaehlt: "Чат не выбран",
    room_chat_start_hint: "Начните беседу! Все сообщения в этом групповом канале децентрализованы и защищены сквозным квантово-безопасным шифрованием.",
    kein_kanal_ausgewaehlt: "Канал не выбран",
    select_channel_chat: "Выберите канал в левой боковой панели, чтобы начать чат.",
    chat_start_hint: "Начните разговор! Все сообщения в чате защищены квантово-безопасным сквозным шифрованием.",
    chat_input_placeholder: "Введите безопасное сообщение...",
    upload_avatar_btn: "Загрузить изображение (очищенное)",
    kryptographische_schluessel: "Криптографические ключи",
    profile_unlock_desc: "По соображениям безопасности вам необходимо ввести свой пароль еще раз, чтобы просмотреть свои закрытые криптографические ключи.",
    unlock_btn_profile: "Разблокировать",
    e2e_chat_room_open: "Открыть чат-комнату E2E",
    spam_verdacht: "Спам/Подозрение",
    no_description: "Нет описания"
  },
  es: {
    // Navigation
    posteingang: "Bandeja de entrada",
    gesendet: "Enviados",
    quanten_chat: "Chat Cuántico",
    gruppen_chats: "Chats de Grupo",
    adressbuch: "Libreta de Direcciones",
    mein_profil: "Mi Perfil",
    identitaets_assistent: "Asistente de Identidad",
    sperren: "Bloquear",
    logout: "Cerrar sesión",
    dunkler_modus: " Modo Oscuro",
    heller_modus: " Modo Claro",
    active_identity: "Identidad Activa",
    setup_profile: "Configurar en el Perfil",
    // Quantum Shield
    quantum_shield_status: " Estado del Quantum Shield",
    post_quantum_e2e: "E2E Post-Cuántico",
    aktiviert: "Activado",
    quantum_shield_desc: "La red GaiaCOM protege su privacidad con un protocolo de cifrado híbrido multicapa seguro contra ataques de futuros ordenadores cuánticos.",
    quantum_shield_l1_title: "1. Protección Post-Cuántica (ML-KEM-1024)",
    quantum_shield_l1_desc: "Utiliza el estándar FIPS 203 para encapsular una clave compartida simétrica. Evita la escucha pasiva y el descifrado posterior (\"Grabe ahora, descifre más tarde\") por parte de ordenadores cuánticos.",
    quantum_shield_l2_title: "2. Criptografía de Curva Elíptica (X25519)",
    quantum_shield_l2_desc: "Un método de intercambio de claves Diffie-Hellman clásico y ultrarrápido que sirve como capa de seguridad adicional en el esquema híbrido.",
    quantum_shield_l3_title: "3. Firmas Digitales (Ed25519)",
    quantum_shield_l3_desc: "Cada mensaje y sobre de federación está firmado criptográficamente para verificar la autenticidad del remitente fuera de toda duda.",
    quantum_shield_l4_title: "4. Autenticación AAD (AES-256-GCM)",
    quantum_shield_l4_desc: "Cifra el contenido del mensaje de forma simétrica y une estrechamente al remitente, destinatario y metadatos en los Datos Adicionales Autenticados (AAD) para evitar ataques de reproducción.",
    close: "Cerrar",
    // Auth Screen
    auth_headline: "GaiaCOM es el primer protocolo de correo electrónico y sistema de comunicación seguro frente a la computación cuántica, creado para la humanidad.",
    auth_subline: "GaiaCOM es un sistema de comunicación resistente a la computación cuántica para correo, chat, salas de crisis, GaiaDrop y registros locales de seguridad. Las claves privadas permanecen en su dispositivo, el contenido se cifra de extremo a extremo y las pruebas pueden exportarse sin revelar texto claro.",
    auth_beta_notice: "Fase beta: GaiaCOM se está probando activamente. Pueden aparecer errores; guarda tus seeds importantes y verifica con cuidado los flujos sensibles.",
    auth_proof_e2ee_desc: "Las claves privadas nunca salen de su dispositivo. Solo los destinatarios previstos pueden descifrar el contenido.",
    auth_proof_gaiadata_desc: "Zero-Knowledge: usted mantiene el control de sus datos. Los metadatos se minimizan y no se convierten en un perfil en texto claro.",
    auth_proof_hybrid_desc: "Quantum Shield: el cifrado híbrido con ML-KEM y X25519 protege frente a ataques actuales y al riesgo de guardar ahora y descifrar después.",
    auth_kicker: "Comunicación segura poscuántica",
    auth_value_mail: "Correo seguro",
    auth_value_chat: "Chat E2E",
    auth_value_rooms: "GaiaRooms",
    auth_value_drop: "Secure Drop",
    auth_proof_gaiaproof_desc: "Las pruebas de entrega e integridad muestran que el texto cifrado, el remitente y la marca temporal no fueron manipulados.",
    auth_proof_gaiadrop_desc: "Personas externas pueden enviar avisos de texto confidenciales a su GaiaID sin tener una cuenta.",
    auth_proof_gaiavault_desc: "Las notas privadas, las pistas de recuperación y los registros de seguridad permanecen cifrados localmente.",
    auth_usecase_title: "Creado para comunicación sensible",
    auth_usecase_text: "Diseñado para abogados, empresas, organismos, periodistas, informantes y casos privados de seguridad.",
    auth_tab_login: "Inicio de sesión / cuenta",
    auth_tab_drop: "GaiaDrop",
    public_drop_desc: "Secure Drop para avisos externos de solo texto sin cuenta GaiaCOM.",
    public_drop_target: "GaiaID de destino",
    public_drop_sender: "Nota opcional del remitente",
    public_drop_sender_placeholder: "Nombre, número de caso o anónimo",
    public_drop_message: "Mensaje",
    public_drop_message_placeholder: "Introduzca texto confidencial...",
    public_drop_send: "Enviar GaiaDrop",
    groups_empty_title: "Aún no hay chats grupales",
    groups_empty_desc: "Cree un espacio de trabajo seguro para proyectos, crisis o comunicación de equipo.",
    auth_secure_mail: "Correo Federado Cuántico Seguro",
    auth_username: "Nombre de usuario",
    auth_username_placeholder: "Ingrese el nombre...",
    auth_password: "Contraseña",
    auth_password_placeholder: "••••••••••••",
    auth_mnemonic: "Frase mnemónica",
    auth_mnemonic_placeholder: "12 palabras separadas por espacios...",
    auth_generate_seed: "Generar semilla",
    auth_copy_seed: "Copiar semilla",
    auth_copied: "Copiado",
    auth_btn_register: "Registrarse y Crear Cripto",
    auth_btn_login: "Cargar Identidad e Iniciar Sesión",
    auth_toggle_register: "Crear nueva cuenta",
    auth_toggle_login: "Ya tengo una cuenta",
    auth_success_title: "Registro Exitoso",
    auth_success_text: "Su cuenta de GaiaCOM ha sido creada. Las claves se derivaron localmente de su semilla y no se almacenaron en el servidor.",
    auth_success_btn: "Iniciar Sesión Ahora",
    // Unlock Screen
    unlock_title: "Desbloquear Identidad",
    unlock_desc: "Su archivo de clave privada está almacenado de forma encriptada. Ingrese su contraseña para cargar las claves criptográficas solo en la memoria RAM.",
    unlock_btn: "Desbloquear",
    unlock_logout: "Cerrar sesión y cerrar claves locales",
    // Setup Wizard
    wizard_step1: "1. Copia de Semilla",
    wizard_step2: "2. Dirección y Servidor",
    wizard_title1: "Asegurar Claves de Recuperación",
    wizard_desc1: "GaiaCOM no almacena claves privadas en el servidor. Sin la semilla mnemónica, nadie puede recuperar mensajes perdidos.",
    wizard_check1: "He guardado de forma segura mi frase semilla.",
    wizard_next: "Siguiente",
    wizard_title2: "Seleccionar Dirección GaiaCOM",
    wizard_desc2: "Su dirección determina el nodo federado a través del cual se enrutan los sobres cifrados.",
    wizard_address: "Dirección",
    wizard_custom_domain: "Usar dominio personalizado",
    wizard_fallback: "Nodos de Respaldo",
    wizard_back: "Atrás",
    wizard_finish: "Finalizar Configuración",
    // Group Settings Modal
    group_settings_title: "Configuración de Grupo",
    group_settings_name: "Nombre de Grupo",
    group_settings_desc: "Descripción",
    group_settings_avatar: "Avatar",
    // General UI
    erfolg: "Éxito",
    fehler: "Error",
    abbrechen: "Cancelar",
    speichern: "Guardar",
    senden: "Enviar",
    mail_compose: "Escribir correo",
    antworten: "Responder",
    gruppe_erstellen: "+ Crear Grupo",
    gruppe_beitreten: "Grupo Unido",
    gruppe_verlassen: "Salir del Grupo",
    einladungscode: "Código de Invitación",
    code_kopieren: "Copiar Código",
    kopiert: "Copiado",
    mitglieder: "Miembros",
    kanaele: "Canales",
    kanal_erstellen: "+ Canal",
    mitglied: "Miembro",
    admin: "Administrador",
    suchen: "Buscar dirección Gaia...",
    profil: "Perfil",
    keine_mails: "No hay correos disponibles.",
    laden: "Cargando...",
    schluessel_entsperrt: "🔑 Bloquear llaves de nuevo",
    // Profile & Password Change
    profile_details: "Detalles del Perfil",
    biography: "Biografía",
    no_specification: "Sin especificar",
    active_identities: "Identidades Activas",
    new_identity: "Nueva Identidad",
    setup_address_keys: "Crear dirección y llaves",
    display_name: "Nombre de Mostrar",
    bio_status: "Biografía / Estado",
    choose_avatar: "Elegir Avatar",
    save_profile: "Guardar Perfil",
    change_password_title: "Cambiar Contraseña",
    change_password_desc: "Cambia tu contraseña de inicio de sesión en el servidor. Tu frase de recuperación local permanece guardada por separado protegida por tu contraseña de Vault/Unlock.",
    current_password: "Contraseña Actual",
    new_password: "Nueva Contraseña",
    confirm_new_password: "Confirmar Nueva Contraseña",
    update_password: "Actualizar Contraseña",
    // Placeholders & Info
    select_contact_chat: "Selecciona un contacto del panel izquierdo para iniciar un chat E2E seguro cuántico.",
    select_mail_read: "Selecciona un correo de la lista para leer sus contenidos cuántico-seguros, o crea un mensaje nuevo.",
    quantum_secure_net: "Red cuántico-segura GaiaCOM (Ed25519 y ML-KEM)",
    quantum_secure_exchange: "Intercambio cuántico-seguro a través de...",
    // GaiaVault
    vault_title: "Caja Fuerte GaiaVault Secure Records",
    vault_desc: "Caja fuerte encriptada local para copias de seguridad de recuperación, notas de identidad, credenciales de servidor, contactos de emergencia, notas legales, eventos de seguridad y registros privados.",
    vault_pwd_placeholder: "Introduce la contraseña de la caja fuerte...",
    vault_btn_unlock: "Desbloquear Caja Fuerte",
    vault_record_title_placeholder: "Título del registro",
    vault_record_body_placeholder: "Introduce el contenido encriptado del registro...",
    vault_btn_encrypt: "Encriptar Registro",
    vault_btn_lock: "Bloquear Caja Fuerte",
    vault_empty: "No hay registros seguros guardados aún.",
    delete: "Borrar",
    // GaiaDrop
    drop_title: "Buzón Seguro GaiaDrop",
    drop_desc: "Canal de entrega anónimo de texto sin conocimiento previo para pistas externas, revelación responsable e informes confidenciales. Usuarios externos pueden enviar mensajes a tu GaiaID sin cuenta.",
    drop_btn_decrypting: "Descifrando buzón...",
    drop_btn_load: "Cargar GaiaDrop Inbox",
    drop_empty: "No hay mensajes de GaiaDrop cargados aún.",
    anonymous_sender: "Remitente Anónimo",
    time_unknown: "Hora desconocida",
    decrypt_failed: "No descifrable",
    // New keys for V2
    confirm_delete_msg: "¿Quieres borrar este mensaje?",
    confirm_delete_everyone: "¿Quieres borrar este mensaje para ambos? (OK = Para todos, Cancelar = Solo para mí)",
    confirm_clear_chat: "¿Quieres vaciar este chat?",
    confirm_clear_everyone: "¿Quieres vaciar este chat para ambos? (OK = Para todos, Cancelar = Solo para mí)",
    edit_profile: "Editar Perfil",
    click_to_write_mail: "Haz clic para escribir un correo",
    message_to_channel: "Mensaje para",
    smtp_security_warning: "Este correo fue transmitido a través del protocolo clásico SMTP sin cifrar. El cifrado de extremo a extremo no está activo.",
    von: "De",
    export_disclosure: "Exportar caso de seguridad",
    melden: "Reportar",
    attachments: "Adjuntos",
    kein_chat_ausgewaehlt: "Ningún chat seleccionado",
    room_chat_start_hint: "¡Comienza la conversación! Todos los mensajes en este canal de grupo están cifrados E2E de forma descentralizada y segura contra cuántica.",
    kein_kanal_ausgewaehlt: "Ningún canal seleccionado",
    select_channel_chat: "Selecciona un canal de la barra lateral izquierda para chatear.",
    chat_start_hint: "¡Comienza la conversación! Todos los mensajes de chat están cifrados E2E de forma cuántica segura.",
    chat_input_placeholder: "Introduce mensaje seguro...",
    upload_avatar_btn: "Subir imagen (Desinfectada)",
    kryptographische_schluessel: "Llaves Criptográficas",
    profile_unlock_desc: "Por razones de seguridad, debes ingresar tu contraseña nuevamente para ver tus llaves criptográficas privadas.",
    unlock_btn_profile: "Desbloquear",
    e2e_chat_room_open: "Abrir sala de chat E2E",
    spam_verdacht: "Spam/Sospecha",
    no_description: "Sin descripción"
  },
  fr: {
    // Navigation
    posteingang: "Boîte de réception",
    gesendet: "Envoyés",
    quanten_chat: "Chat Quantique",
    gruppen_chats: "Chats de Groupe",
    adressbuch: "Carnet d'Adresses",
    mein_profil: "Mon Profil",
    identitaets_assistent: "Assistant d'Identité",
    sperren: "Verrouiller",
    logout: "Se déconnecter",
    dunkler_modus: " Mode Sombre",
    heller_modus: " Mode Clair",
    active_identity: "Identité Active",
    setup_profile: "Configurer dans le Profil",
    // Quantum Shield
    quantum_shield_status: " Statut du Quantum Shield",
    post_quantum_e2e: "E2E Post-Quantique",
    aktiviert: "Activé",
    quantum_shield_desc: "Le réseau GaiaCOM protège votre vie privée avec un protocole de chiffrement hybride externe multicouche sécurisé contre les attaques des futurs ordinateurs quantiques.",
    quantum_shield_l1_title: "1. Protection Post-Quantique (ML-KEM-1024)",
    quantum_shield_l1_desc: "Utilise la norme FIPS 203 pour encapsuler une clé partagée symétrique. Empêche l'écoute passive et le déchiffrement ultérieur (\"Enregistrez maintenant, déchiffrez plus tard\") par les ordinateurs quantiques.",
    quantum_shield_l2_title: "2. Cryptographie sur Courbe Elliptique (X25519)",
    quantum_shield_l2_desc: "Une méthode classique et ultra-rapide d'échange de clés Diffie-Hellman qui sert de couche de sécurité supplémentaire dans le schéma hybride.",
    quantum_shield_l3_title: "3. Signatures Numériques (Ed25519)",
    quantum_shield_l3_desc: "Chaque message et enveloppe de fédération est signé cryptographiquement pour vérifier l'authenticité de l'expéditeur sans aucun doute.",
    quantum_shield_l4_title: "4. Authentification AAD (AES-256-GCM)",
    quantum_shield_l4_desc: "Chiffre le contenu du message de manière symétrique et lie fermement l'expéditeur, le destinataire et les métadonnées dans les Données Additionnelles Authentifiées (AAD) pour empêcher les attaques par rejeu.",
    close: "Fermer",
    // Auth Screen
    auth_headline: "GaiaCOM est le premier protocole e-mail et système de communication sécurisé face au quantique, conçu pour l’humanité.",
    auth_subline: "GaiaCOM est un système de communication résistant au quantique pour le courrier, le chat, les salons de crise, GaiaDrop et les dossiers de sécurité locaux. Les clés privées restent sur votre appareil, le contenu est chiffré de bout en bout et les preuves peuvent être exportées sans révéler le texte clair.",
    auth_beta_notice: "Phase de test bêta : GaiaCOM est testé activement. Des bugs peuvent survenir ; sauvegardez vos seeds importantes et vérifiez soigneusement les usages sensibles.",
    auth_proof_e2ee_desc: "Les clés privées ne quittent jamais votre appareil. Seuls les destinataires prévus peuvent déchiffrer le contenu.",
    auth_proof_gaiadata_desc: "Zero-Knowledge : vous gardez le contrôle de vos données. Les métadonnées sont minimisées et ne deviennent pas un profil en clair.",
    auth_proof_hybrid_desc: "Quantum Shield : le chiffrement hybride avec ML-KEM et X25519 protège contre les attaques actuelles et le risque « stocker maintenant, déchiffrer plus tard ».",
    auth_kicker: "Communication post-quantique sécurisée",
    auth_value_mail: "Courrier sécurisé",
    auth_value_chat: "Chat E2E",
    auth_value_rooms: "GaiaRooms",
    auth_value_drop: "Secure Drop",
    auth_proof_gaiaproof_desc: "Les preuves de livraison et d’intégrité montrent que le texte chiffré, l’expéditeur et l’horodatage n’ont pas été manipulés.",
    auth_proof_gaiadrop_desc: "Des personnes externes peuvent envoyer des signalements confidentiels en texte seul à votre GaiaID sans compte.",
    auth_proof_gaiavault_desc: "Les notes privées, les indices de récupération et les dossiers de sécurité restent chiffrés localement.",
    auth_usecase_title: "Conçu pour les communications sensibles",
    auth_usecase_text: "Adapté aux avocats, entreprises, administrations, journalistes, lanceurs d’alerte et cas de sécurité privés.",
    auth_tab_login: "Connexion / compte",
    auth_tab_drop: "GaiaDrop",
    public_drop_desc: "Secure Drop pour signalements externes en texte seul sans compte GaiaCOM.",
    public_drop_target: "GaiaID cible",
    public_drop_sender: "Note expéditeur optionnelle",
    public_drop_sender_placeholder: "Nom, numéro de dossier ou anonyme",
    public_drop_message: "Message",
    public_drop_message_placeholder: "Saisir un texte confidentiel...",
    public_drop_send: "Envoyer GaiaDrop",
    groups_empty_title: "Aucun chat de groupe pour le moment",
    groups_empty_desc: "Créez un espace de travail sécurisé pour les projets, les crises ou la communication d’équipe.",
    auth_secure_mail: "Courrier Fédéré Quantique Sécurisé",
    auth_username: "Nom d'utilisateur",
    auth_username_placeholder: "Entrez le nom...",
    auth_password: "Mot de passe",
    auth_password_placeholder: "••••••••••••",
    auth_mnemonic: "Phrase mnémotechnique",
    auth_mnemonic_placeholder: "12 mots séparés par des espaces...",
    auth_generate_seed: "Générer la graine",
    auth_copy_seed: "Copier la graine",
    auth_copied: "Copié",
    auth_btn_register: "S'inscrire & Créer la crypto",
    auth_btn_login: "Charger l'identité & Se connecter",
    auth_toggle_register: "Créer un nouveau compte",
    auth_toggle_login: "J'ai déjà un compte",
    auth_success_title: "Inscription réussie",
    auth_success_text: "Votre compte GaiaCOM a été créé. Les clés ont été dérivées localement de votre graine et ne sont pas stockées sur le serveur.",
    auth_success_btn: "Se connecter maintenant",
    // Unlock Screen
    unlock_title: "Déverrouiller l'identité",
    unlock_desc: "Votre fichier de clé privée est stocké de manière chiffrée. Entrez votre mot de passe pour charger les clés cryptographiques uniquement en mémoire vive.",
    unlock_btn: "Déverrouiller",
    unlock_logout: "Se déconnecter et fermer les clés locales",
    // Setup Wizard
    wizard_step1: "1. Sauvegarde de la graine",
    wizard_step2: "2. Adresse et Serveur",
    wizard_title1: "Sécuriser Clés de Récupération",
    wizard_desc1: "GaiaCOM ne stocke pas les clés privées sur le serveur. Sans la graine mnémotechnique, personne ne peut récupérer les messages perdus.",
    wizard_check1: "J'ai sauvegardé ma phrase graine en toute sécurité.",
    wizard_next: "Suivant",
    wizard_title2: "Choisir Adresse GaiaCOM",
    wizard_desc2: "Votre adresse détermine le nœud fédéré par lequel les enveloppes chiffrées sont acheminées.",
    wizard_address: "Adresse",
    wizard_custom_domain: "Utiliser son propre domaine",
    wizard_fallback: "Nœuds de secours",
    wizard_back: "Retour",
    wizard_finish: "Terminer la configuration",
    // Group Settings Modal
    group_settings_title: "Paramètres du Groupe",
    group_settings_name: "Nom du Groupe",
    group_settings_desc: "Description",
    group_settings_avatar: "Avatar",
    // General UI
    erfolg: "Succès",
    fehler: "Erreur",
    abbrechen: "Annuler",
    speichern: "Sauvegarder",
    senden: "Envoyer",
    mail_compose: "Ecrire un mail",
    antworten: "Répondre",
    gruppe_erstellen: "+ Créer un groupe",
    gruppe_beitreten: "Groupe rejoint",
    gruppe_verlassen: "Quitter le groupe",
    einladungscode: "Code d'invitation",
    code_kopieren: "Copier le code",
    kopiert: "Copié",
    mitglieder: "Membres",
    kanaele: "Canaux",
    kanal_erstellen: "+ Canal",
    mitglied: "Membre",
    admin: "Admin",
    suchen: "Rechercher une adresse Gaia...",
    profil: "Profil",
    keine_mails: "Aucun e-mail disponible.",
    laden: "Chargement...",
    schluessel_entsperrt: "🔑 Re-verrouiller les clés",
    // Profile & Password Change
    profile_details: "Détails du Profil",
    biography: "Biographie",
    no_specification: "Non spécifié",
    active_identities: "Identités Actives",
    new_identity: "Nouvelle Identité",
    setup_address_keys: "Créer adresse et clés",
    display_name: "Nom d'Affichage",
    bio_status: "Biographie / Statut",
    choose_avatar: "Choisir l'Avatar",
    save_profile: "Sauvegarder le Profil",
    change_password_title: "Changer de mot de passe",
    change_password_desc: "Modifie votre mot de passe de connexion côté serveur. Votre phrase de récupération locale reste stockée séparément protégée par votre mot de passe de coffre-fort.",
    current_password: "Mot de passe actuel",
    new_password: "Nouveau mot de passe",
    confirm_new_password: "Confirmer le nouveau mot de passe",
    update_password: "Mettre à jour le mot de passe",
    // Placeholders & Info
    select_contact_chat: "Sélectionnez un contact du panneau de gauche pour démarrer une discussion quantique sécurisée E2E.",
    select_mail_read: "Sélectionnez un e-mail dans la liste pour lire son contenu quantique sécurisé, ou créez un nouveau message.",
    quantum_secure_net: "Réseau quantique sécurisé GaiaCOM (Ed25519 & ML-KEM)",
    quantum_secure_exchange: "Échange quantique sécurisé via...",
    // GaiaVault
    vault_title: "Coffre-fort GaiaVault Secure Records",
    vault_desc: "Coffre-fort local chiffré pour sauvegardes de récupération, notes d'identité, identifiants serveur, contacts d'urgence, notes légales, événements de sécurité et journaux privés.",
    vault_pwd_placeholder: "Entrez le mot de passe du coffre-fort...",
    vault_btn_unlock: "Déverrouiller le coffre-fort",
    vault_record_title_placeholder: "Titre de l'enregistrement",
    vault_record_body_placeholder: "Saisir le contenu de l'enregistrement chiffré...",
    vault_btn_encrypt: "Chiffrer l'enregistrement",
    vault_btn_lock: "Verrouiller le coffre-fort",
    vault_empty: "Aucun enregistrement sécurisé stocké pour le moment.",
    delete: "Supprimer",
    // GaiaDrop
    drop_title: "Boîte de dépôt sécurisée GaiaDrop",
    drop_desc: "Canal de dépôt de texte anonyme sans connaissance pour les indices externes, la divulgation responsable et les rapports confidentiels. Les utilisateurs externes peuvent envoyer des messages à votre GaiaID sans compte.",
    drop_btn_decrypting: "Déchiffrement de la boîte...",
    drop_btn_load: "Charger GaiaDrop Inbox",
    drop_empty: "Aucun message GaiaDrop chargé pour le moment.",
    anonymous_sender: "Expéditeur Anonyme",
    time_unknown: "Heure inconnue",
    decrypt_failed: "Non déchiffrable",
    // New keys for V2
    confirm_delete_msg: "Voulez-vous supprimer ce message ?",
    confirm_delete_everyone: "Voulez-vous supprimer ce message pour les deux ? (OK = Pour tout le monde, Annuler = Seulement pour moi)",
    confirm_clear_chat: "Voulez-vous vider ce chat ?",
    confirm_clear_everyone: "Voulez-vous vider ce chat pour les deux ? (OK = Pour tout le monde, Annuler = Seulement pour moi)",
    edit_profile: "Modifier le profil",
    click_to_write_mail: "Cliquez pour écrire un e-mail",
    message_to_channel: "Message à",
    smtp_security_warning: "Ce message a été transmis via le provotole SMTP classique non chiffré. Aucun chiffrement de bout en bout actif.",
    von: "De",
    export_disclosure: "Exporter le dossier de sécurité",
    melden: "Signaler",
    attachments: "Pièces jointes",
    kein_chat_ausgewaehlt: "Aucun chat sélectionné",
    room_chat_start_hint: "Commencez la conversation ! Tous les messages de ce canal de groupe sont décentralisés et chiffrés de bout en bout de manière quantique.",
    kein_kanal_ausgewaehlt: "Aucun canal sélectionné",
    select_channel_chat: "Sélectionnez un canal dans la barre latérale gauche pour discuter.",
    chat_start_hint: "Commencez la conversation ! Tous les messages de discussion sont chiffrés de bout en bout de manière quantique.",
    chat_input_placeholder: "Saisir un message sécurisé...",
    upload_avatar_btn: "Télécharger une image (assainie)",
    kryptographische_schluessel: "Clés cryptographiques",
    profile_unlock_desc: "Pour des raisons de sécurité, vous devez saisir à nouveau votre mot de passe pour afficher vos clés cryptographiques privées.",
    unlock_btn_profile: "Déverrouiller",
    e2e_chat_room_open: "Ouvrir la salle de chat E2E",
    spam_verdacht: "Spam/Suspect",
    no_description: "Pas de description"
  },
  fa: {
    "posteingang": "صندوق ورودی",
    "gesendet": "ارسال شده",
    "quanten_chat": "چت کوانتومی",
    "gruppen_chats": "چت‌های گروهی",
    "adressbuch": "دفترچه تلفن",
    "mein_profil": "پروفایل من",
    "identitaets_assistent": "دستیار هویت",
    "sperren": "قفل کردن",
    "logout": "خروج",
    "dunkler_modus": "حالت تاریک",
    "heller_modus": "حالت روشن",
    "active_identity": "هویت فعال",
    "setup_profile": "تنظیم در پروفایل",
    "quantum_shield_status": "وضعیت سپر کوانتومی",
    "post_quantum_e2e": "پسا کوانتوم سرتاسری",
    "aktiviert": "فعال شده",
    "quantum_shield_desc": "شبکه GaiaCOM از حریم خصوصی شما با یک پروتکل رمزنگاری ترکیبی چند لایه در برابر حملات رایانه‌های کوانتومی آینده محافظت می‌کند.",
    "quantum_shield_l1_title": "۱. محافظت پساکوانتوم (ML-KEM-1024)",
    "quantum_shield_l1_desc": "از استاندارد FIPS 203 برای کپسوله‌سازی کلید مشترک متقارن استفاده می‌کند. از شنود غیرفعال و رمزگشایی بعدی جلوگیری می‌کند.",
    "quantum_shield_l2_title": "۲. رمزنگاری منحنی بیضوی (X25519)",
    "quantum_shield_l2_desc": "یک روش تبادل کلید کلاسیک و بسیار سریع دیفی-هلمن که به عنوان یک لایه امنیتی اضافی کار می‌کند.",
    "quantum_shield_l3_title": "۳. امضاهای دیجیتال (Ed25519)",
    "quantum_shield_l3_desc": "هر پیام و پاکت فدراسیون به صورت رمزنگاری امضا می‌شود تا اصالت فرستنده تأیید شود.",
    "quantum_shield_l4_title": "۴. احراز هویت AAD (AES-256-GCM)",
    "quantum_shield_l4_desc": "محتوای پیام را به صورت متقارن رمزگذاری کرده و متادیتا را برای جلوگیری از حملات تکراری متصل می‌کند.",
    "close": "بستن",
    "auth_kicker": "ارتباط امن پساکوانتومی",
    "auth_headline": "GaiaCOM نخستین پروتکل ایمیل و سیستم ارتباطی امن در برابر کوانتوم است که برای انسانیت ساخته شده است.",
    "auth_subline": "GaiaCOM یک سیستم ارتباطی امن در برابر کوانتوم برای ایمیل، چت، اتاق‌های بحران، GaiaDrop و پرونده‌های امنیتی محلی است. کلیدهای خصوصی روی دستگاه شما می‌مانند، محتوا سرتاسری رمزنگاری می‌شود و شواهد بدون افشای متن اصلی قابل خروجی گرفتن هستند.",
    auth_beta_notice: "مرحله آزمایشی بتا: GaiaCOM به‌طور فعال در حال آزمایش است. ممکن است خطا رخ دهد; seedهای مهم را پشتیبان بگیرید و جریان‌های حساس را با دقت بررسی کنید.",
    "auth_value_mail": "ایمیل امن",
    "auth_value_chat": "چت سرتاسری",
    "auth_value_rooms": "GaiaRooms",
    "auth_value_drop": "Secure Drop",
    "auth_proof_e2ee_desc": "رمزگذاری سرتاسری مطلق: کلیدهای خصوصی هرگز دستگاه شما را ترک نمی‌کنند. هیچ‌کس جز شما قادر به خواندن پیام‌هایتان نیست.",
    "auth_proof_gaiadata_desc": "دانش صفر: کنترل کامل روی داده‌های خود. بدون ردیابی متادیتا.",
    "auth_proof_hybrid_desc": "سپر کوانتومی: رمزنگاری ترکیبی (ML-KEM + X25519) – امن در برابر ابررایانه‌های فردا.",
    "auth_proof_gaiaproof_desc": "اثبات‌های تحویل و یکپارچگی نشان می‌دهند که متن رمز، فرستنده و زمان دستکاری نشده‌اند.",
    "auth_proof_gaiadrop_desc": "افراد بیرونی می‌توانند بدون حساب کاربری، گزارش‌های متنی محرمانه را به GaiaID شما ارسال کنند.",
    "auth_proof_gaiavault_desc": "یادداشت‌های خصوصی، نکات بازیابی و پرونده‌های امنیتی به‌صورت محلی رمزنگاری می‌مانند.",
    "auth_usecase_title": "ساخته‌شده برای ارتباطات حساس",
    "auth_usecase_text": "مناسب برای وکلا، شرکت‌ها، نهادها، روزنامه‌نگاران، افشاگران و پرونده‌های امنیتی خصوصی.",
    "auth_tab_login": "ورود / حساب",
    "auth_tab_drop": "GaiaDrop",
    "public_drop_desc": "Secure Drop برای گزارش‌های متنی بیرونی بدون حساب GaiaCOM.",
    "public_drop_target": "GaiaID مقصد",
    "public_drop_sender": "یادداشت اختیاری فرستنده",
    "public_drop_sender_placeholder": "نام، شماره پرونده یا ناشناس",
    "public_drop_message": "پیام",
    "public_drop_message_placeholder": "متن محرمانه را وارد کنید...",
    "public_drop_send": "ارسال GaiaDrop",
    "auth_secure_mail": "ایمیل فدرال کوانتومی امن",
    "auth_username": "نام کاربری",
    "auth_username_placeholder": "نام کاربری را وارد کنید...",
    "auth_password": "رمز عبور",
    "auth_password_placeholder": "••••••••••••",
    "auth_mnemonic": "عبارت یادآور (Mnemonic)",
    "auth_mnemonic_placeholder": "۱۲ کلمه که با فاصله جدا شده‌اند...",
    "auth_generate_seed": "تولید عبارت یادآور",
    "auth_copy_seed": "کپی عبارت یادآور",
    "auth_copied": "کپی شد",
    "auth_btn_register": "ثبت نام و ایجاد کلیدها",
    "auth_btn_login": "بارگذاری هویت و ورود",
    "auth_toggle_register": "ایجاد حساب کاربری جدید",
    "auth_toggle_login": "قبلاً ثبت نام کرده‌اید",
    "auth_success_title": "ثبت نام با موفقیت انجام شد",
    "auth_success_text": "حساب کاربری GaiaCOM شما ایجاد شد. کلیدها به صورت محلی از عبارت یادآور شما مشتق شده‌اند و روی سرور ذخیره نمی‌شوند.",
    "auth_success_btn": "اکنون وارد شوید",
    "unlock_title": "باز کردن قفل هویت",
    "unlock_desc": "فایل کلید خصوصی شما به صورت رمزگذاری شده ذخیره شده است. رمز عبور خود را برای بارگذاری کلیدها در حافظه موقت وارد کنید.",
    "unlock_btn": "باز کردن قفل",
    "unlock_logout": "خروج و بستن کلیدهای محلی",
    "wizard_step1": "۱. عبارت یادآور پشتیبان",
    "wizard_step2": "۲. آدرس و سرور",
    "wizard_title1": "امن‌سازی کلیدهای بازیابی",
    "wizard_desc1": "GaiaCOM کلیدهای خصوصی را در سرور ذخیره نمی‌کند. بدون عبارت یادآور، هیچ‌کس نمی‌تواند پیام‌های از دست رفته را بازیابی کند.",
    "wizard_check1": "من عبارت یادآور خود را به صورت امن ذخیره کرده‌ام.",
    "wizard_next": "بعدی",
    "wizard_title2": "انتخاب آدرس GaiaCOM",
    "wizard_desc2": "آدرس شما گره فدرالی را تعیین می‌کند که پاکت‌های رمزگذاری شده از طریق آن مسیریابی می‌شوند.",
    "wizard_address": "آدرس",
    "wizard_custom_domain": "استفاده از دامنه اختصاصی",
    "wizard_fallback": "گره‌های پشتیبان",
    "wizard_back": "قبلی",
    "wizard_finish": "اتمام راه‌اندازی",
    "group_settings_title": "تنظیمات گروه",
    "group_settings_name": "نام گروه",
    "group_settings_desc": "توضیحات",
    "group_settings_avatar": "آواتار",
    "erfolg": "موفقیت",
    "fehler": "خطا",
    "abbrechen": "لغو",
    "speichern": "ذخیره",
    "senden": "ارسال",
    mail_compose: "نوشتن ایمیل",
    "antworten": "پاسخ",
    "gruppe_erstellen": "+ ایجاد گروه",
    "gruppe_beitreten": "عضویت در گروه",
    "gruppe_verlassen": "خروج از گروه",
    "einladungscode": "کد دعوت",
    "code_kopieren": "کپی کد",
    "kopiert": "کپی شد",
    "mitglieder": "اعضا",
    "kanaele": "کانال‌ها",
    "kanal_erstellen": "+ کانال",
    "mitglied": "عضو",
    "admin": "مدیر",
    "suchen": "جستجوی آدرس Gaia...",
    "profil": "پروفایل",
    "keine_mails": "هیچ ایمیلی وجود ندارد.",
    "laden": "در حال بارگذاری...",
    "schluessel_entsperrt": "🔑 قفل کردن مجدد کلیدها",
    "profile_details": "جزئیات پروفایل",
    "biography": "بیوگرافی",
    "no_specification": "مشخص نشده",
    "active_identities": "هویت‌های فعال",
    "new_identity": "هویت جدید",
    "setup_address_keys": "ایجاد آدرس و مجموعه کلید",
    "display_name": "نام نمایشی",
    "bio_status": "بیوگرافی / وضعیت",
    "choose_avatar": "انتخاب آواتار",
    "save_profile": "ذخیره پروفایل",
    "change_password_title": "تغییر رمز عبور",
    "change_password_desc": "رمز عبور ورود به سرور شما را تغییر می‌دهد. عبارت بازیابی محلی شما به طور جداگانه توسط رمز عبور صندوق محافظت می‌شود.",
    "current_password": "رمز عبور فعلی",
    "new_password": "رمز عبور جدید",
    "confirm_new_password": "تایید رمز عبور جدید",
    "update_password": "به‌روزرسانی رمز عبور",
    "select_contact_chat": "یک مخاطب را از پنل چپ انتخاب کنید تا چت سرتاسری امن کوانتومی شروع شود.",
    "select_mail_read": "یک ایمیل را از لیست انتخاب کنید تا محتوای امن کوانتومی آن را بخوانید، یا پیام جدیدی ایجاد کنید.",
    "quantum_secure_net": "شبکه امن کوانتومی GaiaCOM (Ed25519 & ML-KEM)",
    "quantum_secure_exchange": "تبادل امن کوانتومی از طریق...",
    "vault_title": "صندوق امن GaiaVault",
    "vault_desc": "صندوق رمزگذاری شده محلی برای پشتیبان‌گیری بازیابی، یادداشت‌های هویت، اعتبارنامه‌های سرور، مخاطبین اضطراری، یادداشت‌های قانونی، رویدادهای امنیتی و گزارش‌های خصوصی.",
    "vault_pwd_placeholder": "رمز عبور صندوق را وارد کنید...",
    "vault_btn_unlock": "باز کردن قفل صندوق",
    "vault_record_title_placeholder": "عنوان رکورد امن",
    "vault_record_body_placeholder": "محتوای رکورد رمزگذاری شده را وارد کنید...",
    "vault_btn_encrypt": "رمزگذاری رکورد",
    "vault_btn_lock": "قفل کردن صندوق",
    "vault_empty": "هنوز هیچ رکورد امنی ذخیره نشده است.",
    "delete": "حذف",
    "drop_title": "صندوق ورودی امن GaiaDrop",
    "drop_desc": "کانال تحویل ناشناس متنی بدون دانش برای سرنخ‌های خارجی، افشاگری‌های مسئولانه و گزارش‌های محرمانه. کاربران خارجی می‌توانند بدون حساب کاربری به GaiaID شما پیام ارسال کنند.",
    "drop_btn_decrypting": "رمزگشایی صندوق ورودی...",
    "drop_btn_load": "بارگذاری صندوق GaiaDrop",
    "drop_empty": "هنوز هیچ پیام GaiaDrop بارگذاری نشده است.",
    "anonymous_sender": "فرستنده ناشناس",
    "time_unknown": "زمان نامشخص",
    "decrypt_failed": "غیرقابل رمزگشایی",
    "confirm_delete_msg": "آیا می‌خواهید این پیام را حذف کنید؟",
    "confirm_delete_everyone": "آیا می‌خواهید این پیام برای هر دو طرف حذف شود؟ (تایید = برای همه، لغو = فقط برای من)",
    "confirm_clear_chat": "آیا می‌خواهید این چت پاک شود؟",
    "confirm_clear_everyone": "آیا می‌خواهید این چت برای هر دو طرف پاک شود؟ (تایید = برای همه، لغو = فقط برای من)",
    "edit_profile": "ویرایش پروفایل",
    "click_to_write_mail": "برای نوشتن ایمیل کلیک کنید",
    "message_to_channel": "پیام به",
    "smtp_security_warning": "این ایمیل از طریق پروتکل کلاسیک و غیررمزگذاری شده SMTP ارسال شده است. رمزگذاری سرتاسری فعال نیست.",
    "von": "از",
    "export_disclosure": "خروجی گرفتن از پرونده امنیتی",
    "melden": "گزارش دادن",
    "attachments": "پیوست‌ها",
    "kein_chat_ausgewaehlt": "هیچ چتی انتخاب نشده است",
    "room_chat_start_hint": "گفتگو را شروع کنید! تمام پیام‌ها در این کانال گروهی به صورت غیرمتمرکز و سرتاسری با امنیت کوانتومی رمزگذاری می‌شوند.",
    "kein_kanal_ausgewaehlt": "هیچ کانالی انتخاب نشده است",
    "select_channel_chat": "یک کانال را از پنل سمت چپ انتخاب کنید تا چت شروع شود.",
    "chat_start_hint": "گفتگو را شروع کنید! تمام پیام‌های چت به صورت سرتاسری با امنیت کوانتومی رمزگذاری شده‌اند.",
    "chat_input_placeholder": "پیام امن را وارد کنید...",
    "upload_avatar_btn": "بارگذاری تصویر (پاک‌سازی شده)",
    "kryptographische_schluessel": "کلیدهای رمزنگاری",
    "profile_unlock_desc": "به دلایل امنیتی، باید رمز عبور خود را دوباره وارد کنید تا کلیدهای رمزنگاری خصوصی خود را مشاهده کنید.",
    "unlock_btn_profile": "باز کردن قفل",
    "e2e_chat_room_open": "باز کردن اتاق چت E2E",
    "spam_verdacht": "هرزنامه / مشکوک",
    "no_description": "بدون توضیحات",
    "groups_empty_title": "هنوز چت گروهی وجود ندارد",
    "groups_empty_desc": "یک فضای کاری امن برای پروژه، بحران یا ارتباط تیمی ایجاد کنید."
  },
  ja: {
    "posteingang": "受信トレイ",
    "gesendet": "送信済み",
    "quanten_chat": "量子チャット",
    "gruppen_chats": "グループチャット",
    "adressbuch": "アドレス帳",
    "mein_profil": "マイプロファイル",
    "identitaets_assistent": "アイデンティティウィザード",
    "sperren": "ロック",
    "logout": "ログアウト",
    "dunkler_modus": " ダークモード",
    "heller_modus": " ライトモード",
    "active_identity": "アクティブアイデンティティ",
    "setup_profile": "プロファイルで設定",
    "quantum_shield_status": " 量子シールドステータス",
    "post_quantum_e2e": "耐量子E2E",
    "aktiviert": "有効化済み",
    "quantum_shield_desc": "GaiaCOMネットワークは、将来の量子コンピュータからの攻撃に対しても安全な、多層ハイブリッド暗号プロトコルであなたのプライバシーを保護します。",
    "quantum_shield_l1_title": "1. ポスト量子保護 (ML-KEM-1024)",
    "quantum_shield_l1_desc": "FIPS 203規格を使用して、対称共有キーをカプセル化します。量子コンピュータによるパッシブな盗聴と後からの復号（「今保存して、後で復号する」）を防止します。",
    "quantum_shield_l2_title": "2. 楕円曲線暗号 (X25519)",
    "quantum_shield_l2_desc": "ハイブリッド方式の追加セキュリティ層として機能する、古典的で非常に高速なDiffie-Hellman鍵共有方式です。",
    "quantum_shield_l3_title": "3. デジタル署名 (Ed25519)",
    "quantum_shield_l3_desc": "送信者の真正性を疑いの余地なく検証するため、すべてのメッセージとフェデレーションエンベロープが暗号署名されます。",
    "quantum_shield_l4_title": "4. AAD認証 (AES-256-GCM)",
    "quantum_shield_l4_desc": "メッセージの内容を対称的に暗号化し、リプレイ攻撃を防ぐために、送信者、受信者、メタデータを「関連データ (AAD)」に強固に結合します。",
    "close": "閉じる",
    "auth_kicker": "ポスト量子セキュア通信",
    "auth_headline": "GaiaCOMは人類のために構築された、世界初の耐量子メールプロトコルと通信システムです。",
    "auth_subline": "GaiaCOMは、メール、チャット、危機対応ルーム、GaiaDrop、ローカルのセキュリティ記録のための耐量子通信システムです。秘密鍵は端末内に留まり、内容はエンドツーエンドで暗号化され、平文を公開せずに証拠をエクスポートできます。",
    auth_beta_notice: "ベータテスト段階です。GaiaCOMは現在検証中で、不具合が発生する場合があります。重要なseedは保管し、機密性の高い操作は慎重に確認してください。",
    "auth_value_mail": "セキュアメール",
    "auth_value_chat": "E2Eチャット",
    "auth_value_rooms": "GaiaRooms",
    "auth_value_drop": "Secure Drop",
    "auth_proof_e2ee_desc": "完全なE2EE: 秘密鍵はデバイスから送信されません。あなた以外の誰もメッセージを読むことはできません。",
    "auth_proof_gaiadata_desc": "ゼロ知識証明: データを完全にコントロール。メタデータの追跡は一切ありません。",
    "auth_proof_hybrid_desc": "クォンタム・シールド: ハイブリッド暗号（ML-KEM + X25519）で明日のスーパーコンピュータからも安全です。",
    "auth_proof_gaiaproof_desc": "配送証明と完全性証明により、暗号文、送信者、時刻が改ざんされていないことを示します。",
    "auth_proof_gaiadrop_desc": "外部の人がアカウントなしで、あなたのGaiaIDへ機密のテキスト報告を送信できます。",
    "auth_proof_gaiavault_desc": "個人メモ、復旧情報、セキュリティ記録はローカルで暗号化されたままです。",
    "auth_usecase_title": "機密性の高い通信のために設計",
    "auth_usecase_text": "弁護士、企業、行政機関、ジャーナリスト、内部告発者、個人のセキュリティ事案に適しています。",
    "auth_tab_login": "ログイン / アカウント",
    "auth_tab_drop": "GaiaDrop",
    "public_drop_desc": "GaiaCOMアカウントなしで外部からテキスト報告を送れるSecure Dropです。",
    "public_drop_target": "宛先GaiaID",
    "public_drop_sender": "任意の送信者メモ",
    "public_drop_sender_placeholder": "名前、案件番号、または匿名",
    "public_drop_message": "メッセージ",
    "public_drop_message_placeholder": "機密テキストを入力...",
    "public_drop_send": "GaiaDropを送信",
    "auth_secure_mail": "安全な量子フェデレーテッドメール",
    "auth_username": "ユーザー名",
    "auth_username_placeholder": "ユーザー名を入力...",
    "auth_password": "パスワード",
    "auth_password_placeholder": "••••••••••••",
    "auth_mnemonic": "助記フレーズ (Mnemonic)",
    "auth_mnemonic_placeholder": "スペースで区切られた12個の単語...",
    "auth_generate_seed": "シードを生成",
    "auth_copy_seed": "シードをコピー",
    "auth_copied": "コピーされました",
    "auth_btn_register": "登録して暗号キーを作成",
    "auth_btn_login": "アイデンティティをロードしてログイン",
    "auth_toggle_register": "新規アカウントを作成",
    "auth_toggle_login": "既にアカウントをお持ちの方",
    "auth_success_title": "登録完了",
    "auth_success_text": "GaiaCOMアカウントが作成されました。キーはシードからローカルに派生されたものであり、サーバーには保存されません。",
    "auth_success_btn": "今すぐログイン",
    "unlock_title": "アイデンティティのロック解除",
    "unlock_desc": "秘密鍵ファイルは暗号化されて保存されています。パスワードを入力して、メモリ内にのみ暗号キーをロードします。",
    "unlock_btn": "ロック解除",
    "unlock_logout": "ログアウトしてローカルキーを閉じる",
    "wizard_step1": "1. バックアップシード",
    "wizard_step2": "2. アドレスとサーバー",
    "wizard_title1": "リカバリキーの保護",
    "wizard_desc1": "GaiaCOMは秘密鍵をサーバー側に保存しません。助記フレーズ（シード）がないと、紛失したメッセージを復元することはできません。",
    "wizard_check1": "シードを安全に保管しました。",
    "wizard_next": "次へ",
    "wizard_title2": "GaiaCOMアドレスの選択",
    "wizard_desc2": "アドレスによって、暗号化されたエンベロープのルーティング先となるフェデレーテッドノードが決定されます。",
    "wizard_address": "アドレス",
    "wizard_custom_domain": "カスタムドメインを使用",
    "wizard_fallback": "フォールバックノード",
    "wizard_back": "戻る",
    "wizard_finish": "セットアップ完了",
    "group_settings_title": "グループ設定",
    "group_settings_name": "グループ名",
    "group_settings_desc": "説明",
    "group_settings_avatar": "アバター",
    "erfolg": "成功",
    "fehler": "エラー",
    "abbrechen": "キャンセル",
    "speichern": "保存",
    "senden": "送信",
    mail_compose: "メール作成",
    "antworten": "返信",
    "gruppe_erstellen": "+ グループを作成",
    "gruppe_beitreten": "グループに参加",
    "gruppe_verlassen": "グループを脱退",
    "einladungscode": "招待コード",
    "code_kopieren": "コードをコピー",
    "kopiert": "コピーされました",
    "mitglieder": "メンバー",
    "kanaele": "チャンネル",
    "kanal_erstellen": "+ チャンネル",
    "mitglied": "メンバー",
    "admin": "管理者",
    "suchen": "Gaiaアドレスを検索...",
    "profil": "プロファイル",
    "keine_mails": "メールはありません。",
    "laden": "ロード中...",
    "schluessel_entsperrt": "🔑 キーを再ロック",
    "profile_details": "プロファイルの詳細",
    "biography": "バイオグラフィー",
    "no_specification": "未指定",
    "active_identities": "アクティブアイデンティティ",
    "new_identity": "新規アイデンティティ",
    "setup_address_keys": "アドレスとキーセットを作成",
    "display_name": "表示名",
    "bio_status": "バイオグラフィー / ステータス",
    "choose_avatar": "アバターを選択",
    "save_profile": "プロファイルを保存",
    "change_password_title": "パスワードの変更",
    "change_password_desc": "サーバー側のログインパスワードを変更します。ローカルの復旧フレーズは、Vault/アンロックパスワードによって個別に保護されたままになります。",
    "current_password": "現在のパスワード",
    "new_password": "新しいパスワード",
    "confirm_new_password": "新しいパスワードの確認",
    "update_password": "パスワードを更新",
    "select_contact_chat": "左側のパネルから連絡先を選択して、量子セキュアなE2Eチャットを開始します。",
    "select_mail_read": "リストからメールを選択して量子セキュアなコンテンツを読むか、新しいメッセージを作成します。",
    "quantum_secure_net": "GaiaCOM 量子セキュアネットワーク (Ed25519 & ML-KEM)",
    "quantum_secure_exchange": "量子セキュアな交換経路...",
    "vault_title": "GaiaVault セキュアレコード",
    "vault_desc": "復旧バックアップ、アイデンティティメモ、サーバー資格情報、緊急連絡先、法的メモ、セキュリティイベント、プライベートログ用のローカル暗号化ボールト。",
    "vault_pwd_placeholder": "ボールトのパスワードを入力...",
    "vault_btn_unlock": "ボールトのロック解除",
    "vault_record_title_placeholder": "セキュアレコードのタイトル",
    "vault_record_body_placeholder": "暗号化されたレコードの内容を入力...",
    "vault_btn_encrypt": "レコードを暗号化",
    "vault_btn_lock": "ボールトをロック",
    "vault_empty": "セキュアレコードはまだ保存されていません。",
    "delete": "削除",
    "drop_title": "GaiaDrop セキュア受信トレイ",
    "drop_desc": "外部からのタレコミ、責任ある開示、および機密報告用のテキスト専用ゼロ知識ドロップチャネル。外部ユーザーは、アカウントなしであなたのGaiaIDを使用してメッセージを送信できます。",
    "drop_btn_decrypting": "受信トレイを復号中...",
    "drop_btn_load": "GaiaDrop受信トレイをロード",
    "drop_empty": "GaiaDrop報告はまだロードされていません。",
    "anonymous_sender": "匿名送信者",
    "time_unknown": "時間不明",
    "decrypt_failed": "復号不可",
    "confirm_delete_msg": "このメッセージを削除しますか？",
    "confirm_delete_everyone": "両方のパートナーのメッセージを削除しますか？ (OK = 全員、キャンセル = 自分のみ)",
    "confirm_clear_chat": "このチャットをクリアしますか？",
    "confirm_clear_everyone": "両方のパートナーのチャットをクリアしますか？ (OK = 全員、キャンセル = 自分のみ)",
    "edit_profile": "プロファイルを編集",
    "click_to_write_mail": "クリックしてメールを作成",
    "message_to_channel": "メッセージ送信先: ",
    "smtp_security_warning": "このメールは、古典的な暗号化されていないSMTPプロトコル経由で送信されました。エンドツーエンド暗号化は有効ではありません。",
    "von": "送信元",
    "export_disclosure": "セキュリティケースをエクスポート",
    "melden": "報告する",
    "attachments": "添付ファイル",
    "kein_chat_ausgewaehlt": "チャットが選択されていません",
    "room_chat_start_hint": "会話を始めましょう！このグループチャネル内のすべてのメッセージは、分散型の量子セキュアE2E暗号化が施されています。",
    "kein_kanal_ausgewaehlt": "チャンネルが選択されていません",
    "select_channel_chat": "左側のサイドバーからチャンネルを選択してチャットを開始します。",
    "chat_start_hint": "会話を始めましょう！すべてのチャットメッセージは、量子セキュアにE2E暗号化されています。",
    "chat_input_placeholder": "安全なメッセージを入力...",
    "upload_avatar_btn": "画像をアップロード (サニタイズ済み)",
    "kryptographische_schluessel": "暗号化キー",
    "profile_unlock_desc": "セキュリティ上の理由から、プライベートな暗号化キーを表示するにはパスワードを再入力する必要があります。",
    "unlock_btn_profile": "ロック解除",
    "e2e_chat_room_open": "E2Eチャットルームを開く",
    "spam_verdacht": "スパム/疑わしい",
    "no_description": "説明なし",
    "groups_empty_title": "グループチャットはまだありません",
    "groups_empty_desc": "プロジェクト、危機対応、チーム連絡のための安全なワークスペースを作成します。"
  }
};
const extendLocale = overrides => ({
  ...translations.en,
  ...overrides
});
Object.assign(translations, {
  pt: extendLocale({
    posteingang: "Entrada",
    gesendet: "Enviados",
    quanten_chat: "Chat quântico",
    gruppen_chats: "Chats de grupo",
    adressbuch: "Contactos",
    mein_profil: "Meu perfil",
    sperren: "Bloquear",
    logout: "Terminar sessão",
    auth_headline: "GaiaCOM é o primeiro protocolo de e-mail e sistema de comunicação seguro contra computação quântica, criado para a humanidade.",
    auth_subline: "GaiaCOM é um sistema de comunicação resistente ao quantum para e-mail, chat, salas de crise, GaiaDrop e registos locais de segurança. As chaves privadas ficam no seu dispositivo, os conteúdos são cifrados de ponta a ponta e as provas podem ser exportadas sem revelar texto claro.",
    auth_beta_notice: "Fase beta: GaiaCOM está em teste ativo. Podem ocorrer erros; guarde seeds importantes e verifique fluxos sensíveis com cuidado.",
    auth_btn_login: "Carregar identidade e entrar",
    auth_toggle_register: "Criar nova conta",
    mail_compose: "Escrever e-mail"
  }),
  ar: extendLocale({
    posteingang: "الوارد",
    gesendet: "المرسل",
    quanten_chat: "دردشة كمية",
    gruppen_chats: "دردشات المجموعات",
    adressbuch: "جهات الاتصال",
    mein_profil: "ملفي",
    sperren: "قفل",
    logout: "تسجيل الخروج",
    auth_headline: "GaiaCOM هو أول بروتوكول بريد إلكتروني ونظام اتصال آمن ضد الحوسبة الكمية، بُني من أجل البشرية.",
    auth_subline: "GaiaCOM نظام اتصال مقاوم للكمّ للبريد والدردشة وغرف الأزمات وGaiaDrop والسجلات الأمنية المحلية. تبقى المفاتيح الخاصة على جهازك، وتُشفّر المحتويات من الطرف إلى الطرف، ويمكن تصدير الأدلة دون كشف النص الواضح.",
    auth_beta_notice: "مرحلة اختبار بيتا: يتم اختبار GaiaCOM بنشاط. قد تظهر أخطاء؛ احتفظ بنسخ احتياطية من seeds المهمة وتحقق من العمليات الحساسة بعناية.",
    auth_btn_login: "تحميل الهوية وتسجيل الدخول",
    auth_toggle_register: "إنشاء حساب جديد",
    mail_compose: "كتابة بريد"
  }),
  zh: extendLocale({
    posteingang: "收件箱",
    gesendet: "已发送",
    quanten_chat: "量子聊天",
    gruppen_chats: "群组聊天",
    adressbuch: "通讯录",
    mein_profil: "我的资料",
    sperren: "锁定",
    logout: "退出登录",
    auth_headline: "GaiaCOM 是为人类构建的首个抗量子电子邮件协议和通信系统。",
    auth_subline: "GaiaCOM 是面向邮件、聊天、危机房间、GaiaDrop 和本地安全记录的抗量子通信系统。私钥保留在你的设备上，内容端到端加密，证据可在不暴露明文的情况下导出。",
    auth_beta_notice: "Beta 测试阶段：GaiaCOM 正在积极测试中，可能会出现错误。请备份重要 seed，并谨慎验证敏感流程。",
    auth_btn_login: "加载身份并登录",
    auth_toggle_register: "创建新账户",
    mail_compose: "写邮件"
  }),
  hi: extendLocale({
    posteingang: "इनबॉक्स",
    gesendet: "भेजे गए",
    quanten_chat: "क्वांटम चैट",
    gruppen_chats: "समूह चैट",
    adressbuch: "संपर्क",
    mein_profil: "मेरी प्रोफ़ाइल",
    sperren: "लॉक",
    logout: "लॉग आउट",
    auth_headline: "GaiaCOM मानवता के लिए बनाया गया पहला क्वांटम-सुरक्षित ई-मेल प्रोटोकॉल और संचार सिस्टम है।",
    auth_subline: "GaiaCOM मेल, चैट, संकट कक्ष, GaiaDrop और स्थानीय सुरक्षा रिकॉर्ड के लिए क्वांटम-प्रतिरोधी संचार प्रणाली है। निजी कुंजियाँ आपके डिवाइस पर रहती हैं, सामग्री एंड-टू-एंड एन्क्रिप्ट होती है और प्रमाण बिना plaintext दिखाए निर्यात किए जा सकते हैं।",
    auth_beta_notice: "बीटा परीक्षण चरण: GaiaCOM सक्रिय परीक्षण में है। त्रुटियाँ हो सकती हैं; महत्वपूर्ण seeds का बैकअप रखें और संवेदनशील वर्कफ़्लो सावधानी से जाँचें।",
    auth_btn_login: "पहचान लोड करें और लॉग इन करें",
    auth_toggle_register: "नया खाता बनाएँ",
    mail_compose: "ई-मेल लिखें"
  }),
  tr: extendLocale({
    posteingang: "Gelen kutusu",
    gesendet: "Gönderilenler",
    quanten_chat: "Kuantum sohbet",
    gruppen_chats: "Grup sohbetleri",
    adressbuch: "Kişiler",
    mein_profil: "Profilim",
    sperren: "Kilitle",
    logout: "Çıkış",
    auth_headline: "GaiaCOM, insanlık için inşa edilen ilk kuantum güvenli e-posta protokolü ve iletişim sistemidir.",
    auth_subline: "GaiaCOM; e-posta, sohbet, kriz odaları, GaiaDrop ve yerel güvenlik kayıtları için kuantuma dayanıklı bir iletişim sistemidir. Özel anahtarlar cihazınızda kalır, içerik uçtan uca şifrelenir ve kanıtlar açık metin göstermeden dışa aktarılabilir.",
    auth_beta_notice: "Beta test aşaması: GaiaCOM aktif olarak test ediliyor. Hatalar oluşabilir; önemli seedleri yedekleyin ve hassas akışları dikkatle doğrulayın.",
    auth_btn_login: "Kimliği yükle ve giriş yap",
    auth_toggle_register: "Yeni hesap oluştur",
    mail_compose: "E-posta yaz"
  }),
  it: extendLocale({
    posteingang: "Posta in arrivo",
    gesendet: "Inviati",
    quanten_chat: "Chat quantistica",
    gruppen_chats: "Chat di gruppo",
    adressbuch: "Contatti",
    mein_profil: "Il mio profilo",
    sperren: "Blocca",
    logout: "Esci",
    auth_headline: "GaiaCOM è il primo protocollo e-mail e sistema di comunicazione sicuro contro il quantum, costruito per l’umanità.",
    auth_subline: "GaiaCOM è un sistema di comunicazione resistente al quantum per e-mail, chat, stanze di crisi, GaiaDrop e registri di sicurezza locali. Le chiavi private restano sul dispositivo, i contenuti sono cifrati end-to-end e le prove possono essere esportate senza rivelare testo in chiaro.",
    auth_beta_notice: "Fase beta: GaiaCOM è in test attivo. Possono verificarsi bug; conserva backup dei seed importanti e verifica con cura i flussi sensibili.",
    auth_btn_login: "Carica identità e accedi",
    auth_toggle_register: "Crea nuovo account",
    mail_compose: "Scrivi e-mail"
  }),
  pl: extendLocale({
    posteingang: "Odebrane",
    gesendet: "Wysłane",
    quanten_chat: "Czat kwantowy",
    gruppen_chats: "Czaty grupowe",
    adressbuch: "Kontakty",
    mein_profil: "Mój profil",
    sperren: "Zablokuj",
    logout: "Wyloguj",
    auth_headline: "GaiaCOM to pierwszy odporny na komputery kwantowe protokół e-mail i system komunikacji zbudowany dla ludzkości.",
    auth_subline: "GaiaCOM to odporna na quantum platforma komunikacji dla poczty, czatu, pokojów kryzysowych, GaiaDrop i lokalnych akt bezpieczeństwa. Klucze prywatne pozostają na urządzeniu, treści są szyfrowane end-to-end, a dowody można eksportować bez ujawniania tekstu jawnego.",
    auth_beta_notice: "Faza beta: GaiaCOM jest aktywnie testowany. Mogą wystąpić błędy; zapisuj kopie ważnych seedów i ostrożnie weryfikuj wrażliwe przepływy.",
    auth_btn_login: "Załaduj tożsamość i zaloguj",
    auth_toggle_register: "Utwórz nowe konto",
    mail_compose: "Napisz e-mail"
  }),
  uk: extendLocale({
    posteingang: "Вхідні",
    gesendet: "Надіслані",
    quanten_chat: "Квантовий чат",
    gruppen_chats: "Групові чати",
    adressbuch: "Контакти",
    mein_profil: "Мій профіль",
    sperren: "Заблокувати",
    logout: "Вийти",
    auth_headline: "GaiaCOM — перший квантово-стійкий протокол електронної пошти та система зв’язку, створена для людства.",
    auth_subline: "GaiaCOM — квантово-стійка система зв’язку для пошти, чатів, кризових кімнат, GaiaDrop і локальних записів безпеки. Приватні ключі залишаються на вашому пристрої, вміст шифрується end-to-end, а докази можна експортувати без розкриття відкритого тексту.",
    auth_beta_notice: "Бета-тест: GaiaCOM активно перевіряється. Можливі помилки; зберігайте резервні копії важливих seed-фраз і уважно перевіряйте чутливі сценарії.",
    auth_btn_login: "Завантажити ідентичність і увійти",
    auth_toggle_register: "Створити новий акаунт",
    mail_compose: "Написати лист"
  }),
  ko: extendLocale({
    posteingang: "받은 편지함",
    gesendet: "보낸 편지함",
    quanten_chat: "양자 보안 채팅",
    gruppen_chats: "그룹 채팅",
    adressbuch: "연락처",
    mein_profil: "내 프로필",
    sperren: "잠금",
    logout: "로그아웃",
    auth_headline: "GaiaCOM은 인류를 위해 구축된 최초의 양자 안전 이메일 프로토콜이자 통신 시스템입니다.",
    auth_subline: "GaiaCOM은 메일, 채팅, 위기 대응 룸, GaiaDrop 및 로컬 보안 기록을 위한 양자 내성 통신 시스템입니다. 개인 키는 기기에 머물고, 콘텐츠는 종단 간 암호화되며, 증거는 평문을 공개하지 않고 내보낼 수 있습니다.",
    auth_beta_notice: "베타 테스트 단계: GaiaCOM은 현재 적극적으로 테스트 중입니다. 오류가 발생할 수 있으므로 중요한 seed를 백업하고 민감한 흐름을 신중히 확인하세요.",
    auth_btn_login: "ID 로드 및 로그인",
    auth_toggle_register: "새 계정 만들기",
    mail_compose: "메일 작성"
  }),
  id: extendLocale({
    posteingang: "Kotak masuk",
    gesendet: "Terkirim",
    quanten_chat: "Chat kuantum",
    gruppen_chats: "Chat grup",
    adressbuch: "Kontak",
    mein_profil: "Profil saya",
    sperren: "Kunci",
    logout: "Keluar",
    auth_headline: "GaiaCOM adalah protokol e-mail dan sistem komunikasi aman-kuantum pertama yang dibangun untuk umat manusia.",
    auth_subline: "GaiaCOM adalah sistem komunikasi tahan-kuantum untuk e-mail, chat, ruang krisis, GaiaDrop, dan catatan keamanan lokal. Kunci privat tetap di perangkat Anda, konten dienkripsi end-to-end, dan bukti dapat diekspor tanpa membuka plaintext.",
    auth_beta_notice: "Fase uji beta: GaiaCOM sedang diuji aktif. Bug dapat terjadi; cadangkan seed penting dan verifikasi alur sensitif dengan hati-hati.",
    auth_btn_login: "Muat identitas dan masuk",
    auth_toggle_register: "Buat akun baru",
    mail_compose: "Tulis e-mail"
  })
});
const deviceLabels = {
  device_sessions_title: "Signed-in devices",
  device_sessions_desc: "Review active sessions and sign out devices you no longer trust.",
  device_sessions_empty: "No devices found.",
  device_since: "Since",
  device_last_seen: "Last seen",
  device_current: "This device",
  device_logout: "Sign out",
  loading: "Loading...",
  refresh: "Refresh"
};
const uiLabels = {
  add_btn: "Add",
  add_contact_title: "Add contact",
  attachment_gaia_hint: "GaiaCOM attachments stay encrypted end-to-end.",
  attachment_smtp_hint: "Legacy SMTP blocks executable/script-like attachments and stores mail as untrusted.",
  bestaetigen: "Confirm",
  channel_name_label: "Channel name",
  clear_chat: "Clear chat",
  clear_for_everyone: "Clear for everyone",
  clear_for_me: "Clear for me",
  code_kopieren_success: "Code copied",
  confirm_clear_channel_desc: "Clear this channel from your local view?",
  confirm_clear_channel_title: "Clear channel",
  confirm_clear_chat_desc: "Do you want to clear this chat?",
  confirm_clear_chat_title: "Clear chat",
  confirm_delete_msg_desc: "Do you want to delete this chat message?",
  confirm_delete_msg_title: "Delete message",
  create_btn: "Create",
  create_channel_title: "Create channel",
  create_group_is_crisis: "Mark as crisis room",
  create_group_title: "Create new group",
  delete_for_everyone: "Delete for everyone",
  delete_for_me: "Delete for me",
  drop_delete_desc: "Do you really want to permanently delete this drop?",
  drop_delete_title: "Delete GaiaDrop",
  enter_fingerprint_chars_confirm: "Enter the requested fingerprint characters to confirm.",
  exclude_plaintext: "Export without plaintext",
  export_package_desc: "Include plaintext in the security export only if disclosure is intended.",
  export_package_title: "Export security package",
  group_delete_desc: "Do you really want to permanently delete this group? All channels and messages in this group will be deleted.",
  group_delete_title: "Delete group",
  group_description: "Description",
  group_icon_label: "Group icon / avatar",
  group_name: "Group name",
  group_settings_is_crisis: "Mark as crisis room",
  include_plaintext: "Include plaintext",
  invite_code_label: "Invite code",
  join_group_title: "Join group",
  keine_gruppe_ausgewaehlt: "No group selected",
  key_change_warn_desc: "The public key for this contact has changed. Verify the fingerprint before trusting it.",
  key_change_warn_title: "Cryptographic warning",
  leeren: "Clear",
  message: "Message",
  neue_mail: "New mail",
  new_fingerprint: "New fingerprint",
  old_fingerprint: "Old fingerprint",
  profile_settings_hint: "Profile settings are shown in the right panel.",
  receiver_gaia: "GaiaCOM recipient",
  receiver_smtp: "SMTP recipient",
  records_stored: "records stored",
  report_abuse_desc: "Report this message and submit a cryptographic abuse proof to the server?",
  report_abuse_title: "Report abuse",
  search_gaia_label: "Search Gaia address",
  security_warning_title: "Security warning",
  smtp_mode_option: "Legacy SMTP bridge",
  smtp_legacy_badge: "Legacy SMTP / unsafe",
  smtp_security_warning_desc: "Legacy SMTP is active but unsafe: no GaiaCOM E2EE, red untrusted marking, and risky attachments are blocked.",
  spam_warning_desc: "This message has suspicious reputation signals.",
  spam_warning_title: "Spam warning",
  subject: "Subject",
  transmission_mode: "Transmission mode",
  trust_passport_title: "Trust passport",
  vault_copied_success: "Copied to clipboard",
  vault_decrypted_content: "Decrypted content",
  vault_new_record: "New secure record",
  vault_record_body: "Record content",
  vault_record_category: "Category",
  vault_record_title: "Record title",
  verify_new_fingerprint_hint: "Verify the new fingerprint before accepting the key.",
  write_message_placeholder: "Write a secure message...",
  "Chat fuer alle geleert": "Chat cleared for everyone",
  "Chat geleert": "Chat cleared",
  "Nachricht fuer alle geloescht": "Message deleted for everyone",
  "Nachricht geloescht": "Message deleted"
};
Object.keys(translations).forEach(lang => {
  translations[lang] = {
    ...uiLabels,
    ...deviceLabels,
    ...translations[lang]
  };
});
Object.assign(translations.de, {
  device_sessions_title: "Angemeldete Geräte",
  device_sessions_desc: "Prüfe aktive Sitzungen und melde Geräte ab, denen du nicht mehr vertraust.",
  device_sessions_empty: "Keine Geräte gefunden.",
  device_since: "Seit",
  device_last_seen: "Zuletzt",
  device_current: "Dieses Gerät",
  device_logout: "Abmelden",
  loading: "Laden...",
  refresh: "Aktualisieren",
  add_btn: "Hinzufügen",
  add_contact_title: "Kontakt hinzufügen",
  attachment_gaia_hint: "GaiaCOM-Anhänge bleiben Ende-zu-Ende verschlüsselt.",
  attachment_smtp_hint: "Legacy-SMTP blockt ausführbare/scriptartige Anhänge und speichert Mails als unsicher.",
  bestaetigen: "Bestätigen",
  channel_name_label: "Kanalname",
  clear_chat: "Chat leeren",
  clear_for_everyone: "Für alle leeren",
  clear_for_me: "Nur für mich leeren",
  code_kopieren_success: "Code kopiert",
  confirm_clear_channel_desc: "Möchtest du diesen Kanal aus deiner lokalen Ansicht leeren?",
  confirm_clear_channel_title: "Kanal leeren",
  confirm_clear_chat_desc: "Möchtest du diesen Chat leeren?",
  confirm_clear_chat_title: "Chat leeren",
  confirm_delete_msg_desc: "Möchtest du diese Chat-Nachricht löschen?",
  confirm_delete_msg_title: "Nachricht löschen",
  create_btn: "Erstellen",
  create_channel_title: "Kanal erstellen",
  create_group_is_crisis: "Als Krisenraum markieren",
  create_group_title: "Neue Gruppe erstellen",
  delete_for_everyone: "Für alle löschen",
  delete_for_me: "Nur für mich löschen",
  drop_delete_desc: "Möchtest du diesen Drop wirklich unwiderruflich löschen?",
  drop_delete_title: "GaiaDrop löschen",
  enter_fingerprint_chars_confirm: "Gib die angeforderten Fingerprint-Zeichen zur Bestätigung ein.",
  exclude_plaintext: "Ohne Klartext exportieren",
  export_package_desc: "Klartext nur aufnehmen, wenn diese Offenlegung bewusst vorgesehen ist.",
  export_package_title: "Sicherheits-Paket exportieren",
  group_delete_desc: "Möchtest du diese Gruppe wirklich unwiderruflich löschen? Alle Kanäle und Nachrichten dieser Gruppe werden gelöscht.",
  group_delete_title: "Gruppe löschen",
  group_description: "Beschreibung",
  group_icon_label: "Gruppen-Icon / Avatar",
  group_name: "Gruppenname",
  group_settings_is_crisis: "Als Krisenraum markieren",
  include_plaintext: "Klartext einschließen",
  invite_code_label: "Einladungscode",
  join_group_title: "Gruppe beitreten",
  keine_gruppe_ausgewaehlt: "Keine Gruppe ausgewählt",
  key_change_warn_desc: "Der öffentliche Schlüssel dieses Kontakts hat sich geändert. Prüfe den Fingerprint, bevor du ihm vertraust.",
  key_change_warn_title: "Kryptographische Warnung",
  leeren: "Leeren",
  message: "Nachricht",
  neue_mail: "Neue Mail",
  new_fingerprint: "Neuer Fingerprint",
  old_fingerprint: "Alter Fingerprint",
  profile_settings_hint: "Profil-Einstellungen werden im rechten Panel angezeigt.",
  receiver_gaia: "GaiaCOM-Empfänger",
  receiver_smtp: "SMTP-Empfänger",
  records_stored: "Records gespeichert",
  report_abuse_desc: "Möchtest du diese Nachricht melden und einen kryptographischen Missbrauchsbeweis an den Server übermitteln?",
  report_abuse_title: "Missbrauch melden",
  search_gaia_label: "Gaia-Adresse suchen",
  security_warning_title: "Sicherheitswarnung",
  smtp_mode_option: "Legacy-SMTP-Bridge",
  smtp_legacy_badge: "Legacy SMTP / Unsicher",
  smtp_security_warning_desc: "Legacy-SMTP ist aktiv, aber unsicher: keine GaiaCOM-E2EE, rote Unsicher-Markierung und blockierte Risiko-Anhänge.",
  spam_warning_desc: "Diese Nachricht hat verdächtige Reputationssignale.",
  spam_warning_title: "Spam-Warnung",
  subject: "Betreff",
  transmission_mode: "Übertragungsmodus",
  trust_passport_title: "Trust Passport",
  vault_copied_success: "In die Zwischenablage kopiert",
  vault_decrypted_content: "Entschlüsselter Inhalt",
  vault_new_record: "Neuer Secure Record",
  vault_record_body: "Record-Inhalt",
  vault_record_category: "Kategorie",
  vault_record_title: "Record-Titel",
  verify_new_fingerprint_hint: "Prüfe den neuen Fingerprint, bevor du den Schlüssel akzeptierst.",
  write_message_placeholder: "Sichere Nachricht schreiben...",
  "Chat fuer alle geleert": "Chat für alle geleert",
  "Chat geleert": "Chat geleert",
  "Nachricht fuer alle geloescht": "Nachricht für alle gelöscht",
  "Nachricht geloescht": "Nachricht gelöscht"
});
const LanguageContext = React.createContext();
export function LanguageProvider({
  children
}) {
  const [language, setLanguageState] = useState(() => {
    return localStorage.getItem('gaia_lang') || 'de';
  });
  const changeLanguage = lang => {
    if (translations[lang]) {
      setLanguageState(lang);
      localStorage.setItem('gaia_lang', lang);
    }
  };
  const t = key => {
    const langData = translations[language] || translations.de;
    return langData[key] || translations.de[key] || key;
  };
  return <LanguageContext.Provider value={{
    language,
    changeLanguage,
    t
  }}>
      {children}
    </LanguageContext.Provider>;
}
export function useTranslation() {
  const context = React.useContext(LanguageContext);
  if (!context) {
    throw new Error('useTranslation must be used within a LanguageProvider');
  }
  return context;
}
